webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _conf = __webpack_require__(1);
	
	var _conf2 = _interopRequireDefault(_conf);
	
	var _optimizedEvents = __webpack_require__(2);
	
	var _optimizedEvents2 = _interopRequireDefault(_optimizedEvents);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _AjaxSvg = __webpack_require__(5);
	
	var _AjaxSvg2 = _interopRequireDefault(_AjaxSvg);
	
	var _ScrollToTop = __webpack_require__(6);
	
	var _ScrollToTop2 = _interopRequireDefault(_ScrollToTop);
	
	var _buttonBacktotop = __webpack_require__(8);
	
	var _buttonBacktotop2 = _interopRequireDefault(_buttonBacktotop);
	
	var _bottomEffect = __webpack_require__(9);
	
	var _bottomEffect2 = _interopRequireDefault(_bottomEffect);
	
	var _lightbox = __webpack_require__(11);
	
	var _sliderLightbox = __webpack_require__(13);
	
	var _sliderLightbox2 = _interopRequireDefault(_sliderLightbox);
	
	var _sticky = __webpack_require__(17);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _anchor = __webpack_require__(18);
	
	var _navigationSwipe = __webpack_require__(20);
	
	var _navigationSwipe2 = _interopRequireDefault(_navigationSwipe);
	
	var _responsiveSwipeItem = __webpack_require__(21);
	
	var _responsiveSwipeItem2 = _interopRequireDefault(_responsiveSwipeItem);
	
	var _header = __webpack_require__(22);
	
	var _tabQuarterly = __webpack_require__(23);
	
	var _tabQuarterly2 = _interopRequireDefault(_tabQuarterly);
	
	var _careerForm = __webpack_require__(24);
	
	var _careerForm2 = _interopRequireDefault(_careerForm);
	
	var _sponsorForm = __webpack_require__(25);
	
	var _sponsorForm2 = _interopRequireDefault(_sponsorForm);
	
	var _heightBringer = __webpack_require__(26);
	
	var _heightBringer2 = _interopRequireDefault(_heightBringer);
	
	var _cardThumbnail = __webpack_require__(27);
	
	var _cardThumbnail2 = _interopRequireDefault(_cardThumbnail);
	
	var _accordion = __webpack_require__(29);
	
	var _accordion2 = _interopRequireDefault(_accordion);
	
	var _mosaic = __webpack_require__(30);
	
	var _mosaic2 = _interopRequireDefault(_mosaic);
	
	var _dropdownMenu = __webpack_require__(31);
	
	var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);
	
	var _burger = __webpack_require__(32);
	
	var _burger2 = _interopRequireDefault(_burger);
	
	var _tabPanel = __webpack_require__(33);
	
	var _tabPanel2 = _interopRequireDefault(_tabPanel);
	
	var _slider = __webpack_require__(14);
	
	var _syncSearchPage = __webpack_require__(34);
	
	var _syncSearchPage2 = _interopRequireDefault(_syncSearchPage);
	
	var _quote = __webpack_require__(35);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _twitter = __webpack_require__(40);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _jobOffer = __webpack_require__(42);
	
	var _jobOffer2 = _interopRequireDefault(_jobOffer);
	
	var _squareList = __webpack_require__(43);
	
	var _squareList2 = _interopRequireDefault(_squareList);
	
	var _truncate = __webpack_require__(44);
	
	var _truncate2 = _interopRequireDefault(_truncate);
	
	var _scrollToFormError = __webpack_require__(46);
	
	var _scrollToFormError2 = _interopRequireDefault(_scrollToFormError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _optimizedEvents2.default)(['resize', 'scroll']);
	
	var ajaxSvg = new _AjaxSvg2.default();
	var scrollToTop = new _ScrollToTop2.default();
	var lightbox = new _lightbox.Lightbox('lightbox', QUEBECOR_TRANSLATE.close);
	var burger = new _burger2.default();
	
	ajaxSvg.init(_conf2.default.imgPath + 'sprite/symbol/svg/sprite.symbol.svg');
	scrollToTop.init('.js-back-to-top');
	
	/* eslint-disable max-statements */
	_domUtilities2.default.onEvent(window, 'DOMContentLoaded', function () {
	
	    (0, _syncSearchPage2.default)();
	    (0, _bottomEffect2.default)('.page', '.page-bottom-effect');
	    (0, _tabQuarterly2.default)();
	    (0, _careerForm2.default)();
	    (0, _sponsorForm2.default)();
	    (0, _heightBringer2.default)();
	    (0, _tabPanel2.default)();
	
	    (0, _jobOffer2.default)();
	
	    (0, _scrollToFormError2.default)();
	
	    (0, _buttonBacktotop2.default)();
	
	    (0, _sliderLightbox2.default)(lightbox);
	    (0, _slider.initSliders)('.js-slider'); // For sliders on document
	
	    var navbar = document.querySelector('.navbar');
	    var scrollDowmAction = document.querySelector('.js-hero__scroll');
	
	    if (scrollDowmAction !== null) {
	        (0, _header.scrollDown)(scrollDowmAction);
	    }
	
	    var videoContainer = document.querySelector('[data-header-video]');
	    var controlContainer = document.querySelector('[data-header-video-parent-control]');
	
	    if (videoContainer && controlContainer && Modernizr.video) {
	        (0, _header.initHeaderVideo)(videoContainer, controlContainer);
	    }
	
	    if (navbar !== null) {
	        (0, _sticky2.default)(navbar, navbar.offsetHeight, 'navbar--sticky', _conf2.default.mq.mm, 'navbar-is-sticky');
	    }
	
	    var anchorsMenu = new _anchor.Anchors();
	    anchorsMenu.init('.anchor__content', '.js-anchors-frame');
	
	    var anchors = document.querySelector('.anchors');
	
	    if (anchors !== null) {
	        var anchorsOffset = parseFloat(window.getComputedStyle(document.querySelector('.header')).height);
	        (0, _sticky2.default)(anchors, anchorsOffset, 'anchors--sticky', _conf2.default.mq.mm, 'anchors-is-sticky');
	    }
	
	    (0, _navigationSwipe2.default)('.js-navigation-swipe');
	
	    var lastTweet = new _twitter2.default();
	    lastTweet.init();
	    (0, _responsiveSwipeItem2.default)('data-responsive-swipe-item');
	    (0, _mosaic2.default)();
	    (0, _cardThumbnail2.default)('[data-card-thumbnail]', lightbox);
	
	    (0, _accordion2.default)();
	
	    (0, _dropdownMenu2.default)();
	
	    var burgerNav = document.querySelector(burger.burger);
	    if (burgerNav) {
	        burger.init(burgerNav);
	    }
	
	    var quote = new _quote2.default();
	    quote.init();
	    (0, _squareList2.default)();
	
	    (0, _truncate2.default)();
	});
	/* eslint-enable max-statement */

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    imgPath: typeof imgPath === 'undefined' ? '/o/quebecor-theme/images/' : imgPath,
	    styles: {
	        baseFontSize: 15
	    },
	    mq: { // Important, keep it sync with config.scss
	        lg: 1260,
	        md: 992,
	        mm: 920,
	        smmin: 768,
	        sm: 769,
	        xs: 520,
	        xxs: 380
	    }
	};

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (EventNames) {
	    var throttle = function throttle(type, name) {
	        var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window;
	
	        var running = false;
	        var func = function func() {
	            if (running) {
	                return;
	            }
	            running = true;
	            (0, _rafPolyfill2.default)(function () {
	                _domUtilities2.default.triggerEvent(obj, name);
	                running = false;
	            });
	        };
	        obj.addEventListener(type, func);
	    };
	
	    EventNames.forEach(function (eventName) {
	        throttle(eventName, 'optimized-' + eventName);
	    });
	};
	
	var _rafPolyfill = __webpack_require__(3);
	
	var _rafPolyfill2 = _interopRequireDefault(_rafPolyfill);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	
	/**
	 * Throttle an optimized event with requestAnimationFrame
	 *
	 * @param {String[]} EventNames Array of event name to throttle
	 */

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Inspired from
	 * https://gist.github.com/jlmakes/47eba84c54bc306186ac1ab2ffd336d4
	 */
	
	var polyfill = function () {
	    var clock = +new Date();
	
	    return function (callback) {
	
	        var currentTime = +new Date();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                polyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || polyfill;
	
	exports.default = requestAnimationFrame;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * DOM Utilities
	 */
	var du = function () {
	    function du() {
	        _classCallCheck(this, du);
	    }
	
	    _createClass(du, null, [{
	        key: 'setAttrs',
	
	        // @param  {Node} `el` The base element
	        // @param {Object} `attrs` The key/value list of attributes
	        // @return {Node} `el`
	        // @usage du.setAttrs(el, {'role' : 'tab', 'tabindextab' : '0', ...});
	        // Setting multiple attributes to an element
	        value: function setAttrs(el, attrs) {
	            var key;
	
	            if (isElement(el) && isObject(attrs)) {
	                for (key in attrs) {
	                    if (attrs.hasOwnProperty(key)) {
	                        el.setAttribute(key, attrs[key]);
	                    }
	                }
	            } else {
	                console.log('Error "' + el + '" should be a DOM element!!');
	                console.log('Error "' + attrs + '" should be an Object!!');
	            }
	        }
	
	        // addEventListener fallback for IE 8 lte
	
	    }, {
	        key: 'onEvent',
	        value: function onEvent(el, eventName, handler) {
	            if (window.addEventListener) {
	                el.addEventListener(eventName, handler, false);
	            } else {
	                el.attachEvent('on' + eventName, function () {
	                    handler.call(el);
	                });
	            }
	        }
	
	        /**
	         * addEventListener fallback for IE 8 lte with multi events support
	         * @param {HTMLElement} el Required. Element watched by the function.
	         * @param {String} eventsName Required. A String that specifies the names of the events separated by ' '.
	         * @param {function} handler Required. Specifies the function to run when the event occurs.
	         */
	
	    }, {
	        key: 'onEvents',
	        value: function onEvents() {
	            var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var eventsName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            if (!el || !eventsName || !handler) {
	                return;
	            }
	            if (el.nodeType === 1) {
	                eventsName.split(' ').forEach(function (eventName) {
	                    if (window.addEventListener) {
	                        el.addEventListener(eventName, handler, false);
	                    } else {
	                        el.attachEvent('on' + eventName, function () {
	                            handler.call(el);
	                        });
	                    }
	                });
	            }
	        }
	
	        // addEventListener on NodeList
	        // var some_nodes = document.querySelectorAll('.noeuds');
	        // onEventNL(some_nodes, 'click', doSomethingFunction);
	
	    }, {
	        key: 'onEventNL',
	        value: function onEventNL(nlist, event, fn) {
	            var lengthOf = nlist.length;
	
	            while (lengthOf--) {
	                onEvent(nlist[lengthOf], event, fn);
	            }
	        }
	
	        // Array.indexOf for IE 8 gte
	
	    }, {
	        key: 'getIndex',
	        value: function getIndex(array, item) {
	            var lengthOf = array.length;
	
	            while (lengthOf--) {
	                if (array[lengthOf] === item) {
	                    return lengthOf;
	                }
	            }
	
	            return -1;
	        }
	
	        // GetHeight
	        // Get the largest measurement height
	
	    }, {
	        key: 'getHeight',
	        value: function getHeight(el) {
	            return Math.max(el.scrollHeight, el.offsetHeight, el.clientHeight);
	        }
	
	        // setClass
	        // Add a class to an element
	
	    }, {
	        key: 'setClass',
	        value: function setClass(el, classname) {
	            if (el.classList) {
	                el.classList.add(classname);
	            } else {
	                el.className += ' ' + classname;
	            }
	        }
	
	        // @param  {Node} `el` The base element
	        // @return {Number} The outerHeight(true) of the `el` element.
	
	    }, {
	        key: 'outerHeight',
	        value: function outerHeight(el) {
	            var height = el.offsetHeight,
	                style = getComputedStyle(el),
	                marginTop = parseInt(style.marginTop) || 0,
	                marginBottom = parseInt(style.marginBottom) || 0;
	
	            height += marginTop + marginBottom;
	            return height;
	        }
	    }, {
	        key: 'returnMaxOuterHeight',
	
	
	        /**
	         * return the max outerHeight from an element
	         * @param  {String} cssClass
	         * @param {HTMLElement} context NodeList
	         * @return {int}    max height
	         */
	        value: function returnMaxOuterHeight(cssClass) {
	            var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
	
	            var max = 0;
	            var tmp = 0;
	            du.queryAll(cssClass, parent).forEach(function (item) {
	                if ((tmp = du.outerHeight(item)) > max) {
	                    max = tmp;
	                }
	            });
	            return max;
	        }
	
	        // unsetClass
	        // Remove a class from an element
	
	    }, {
	        key: 'unsetClass',
	        value: function unsetClass(el, classname) {
	            if (el.classList) {
	                el.classList.remove(classname);
	            } else {
	                el.className = el.className.replace(new RegExp('(^|\\b)' + classname.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	            }
	        }
	
	        /**
	         * hasClass
	         * Return true if an element has a specific class
	         * @static
	         * @param {HTMLElement} el
	         * @param {String} classname
	         * @returns true if an element has a specific class
	         *
	         * @memberOf du
	         */
	
	    }, {
	        key: 'hasClass',
	        value: function hasClass(el, classname) {
	            if (el.classList) {
	                return el.classList.contains(classname);
	            } else {
	                return new RegExp('(^| )' + classname + '( |$)', 'gi').test(el.className);
	            }
	        }
	
	        /**
	         * toggleClass
	         * Toggle a class true if an element has a specific class
	         * @static
	         * @param {HTMLElement} el
	         * @param {String} classname
	         * @returns
	         *
	         * @memberOf du
	         */
	
	    }, {
	        key: 'toggleClass',
	        value: function toggleClass(el, classname) {
	            if (du.hasClass(el, classname)) {
	                unsetClass(el, classname);
	            } else {
	                setClass(el, classname);
	            }
	
	            return;
	        }
	    }, {
	        key: 'setDebounce',
	
	
	        // setDebounce
	        // Source : <http://www.grafikart.fr/tutoriels/javascript/debounce-throttle-642>
	        // Usage : search.addEventListener('keyup', du.setDebounce(function(e) {...}, 350))
	        value: function setDebounce(callback) {
	            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	
	            var timer;
	
	            return function () {
	                var args = arguments;
	                var context = this;
	
	                clearTimeout(timer);
	
	                timer = setTimeout(function () {
	                    callback.apply(context, args);
	                }, delay);
	            };
	        }
	
	        // setThrottle
	        // Source : <http://www.grafikart.fr/tutoriels/javascript/debounce-throttle-642>
	        // Usage : window.addEventListener('scroll', du.setThrottle(function(e) {...}, 50))
	
	    }, {
	        key: 'setThrottle',
	        value: function setThrottle(callback) {
	            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
	
	            var last;
	            var timer;
	
	            return function () {
	                var context = this;
	                var now = +new Date();
	                var args = arguments;
	
	                if (last && now < last + delay) {
	                    clearTimeout(timer);
	
	                    timer = setTimeout(function () {
	                        last = now;
	                        callback.apply(context, args);
	                    }, delay);
	                } else {
	                    last = now;
	                    callback.apply(context, args);
	                }
	            };
	        }
	
	        // slideDown
	        // Usage : du.slideDown($panel);
	
	    }, {
	        key: 'slideDown',
	        value: function slideDown(el) {
	            var elMaxHeight = 0;
	
	            if (el.getAttribute('data-maxheight')) {
	                // we've already used this before, so everything is setup
	                if (el.style.maxHeight.replace('px', '').replace('%', '') === '0') {
	                    el.style.maxHeight = el.getAttribute('data-maxheight');
	                }
	            } else {
	                elMaxHeight = getHeight(el) + 'px';
	                el.style['transition'] = 'max-height 0.25s ease-in-out, opacity 0.25s ease-in-out';
	                el.style.overflowY = 'hidden';
	                el.style.maxHeight = '0';
	                el.setAttribute('data-maxheight', elMaxHeight);
	                el.style.display = 'block';
	
	                // we use setTimeout to modify maxHeight later than display (to we have the transition effect)
	                setTimeout(function () {
	                    el.style.maxHeight = elMaxHeight;
	                }, 10);
	            }
	
	            el.style.opacity = '1';
	        }
	
	        // slideUp
	        // Usage : du.slideUp($panel);
	
	    }, {
	        key: 'slideUp',
	        value: function slideUp(el) {
	            if (el.getAttribute('data-maxheight')) {
	                // we've already used this before, so everything is setup
	                if (el.style.maxHeight.replace('px', '').replace('%', '') !== '0') {
	                    el.style.maxHeight = '0';
	                }
	            }
	
	            el.style.opacity = '0';
	        }
	
	        // Is a given value a DOM element?
	
	    }, {
	        key: 'isElement',
	        value: function isElement(obj) {
	            return !!(obj && obj.nodeType === 1);
	        }
	
	        // Is a given variable an object?
	
	    }, {
	        key: 'isObject',
	        value: function isObject(obj) {
	            var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
	
	            return type === 'function' || type === 'object' && !!obj;
	        }
	
	        /**
	         * Merge defaults with user options
	         *
	         * @param {Object} defaults Default settings
	         * @param {Object} options User options
	         * @returns {Object} Merged values of defaults and options
	         */
	
	    }, {
	        key: 'extend',
	        value: function extend(defaults, options) {
	            var extended = {};
	            var prop = void 0;
	            for (prop in defaults) {
	                if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
	                    extended[prop] = defaults[prop];
	                }
	            }
	            for (prop in options) {
	                if (Object.prototype.hasOwnProperty.call(options, prop)) {
	                    extended[prop] = options[prop];
	                }
	            }
	            return extended;
	        }
	
	        // Usage : triggerEvent(element, 'mousedown');
	
	    }, {
	        key: 'triggerEvent',
	        value: function triggerEvent(el, type) {
	            var e;
	
	            if ('createEvent' in document) {
	                // modern browsers, IE9+
	                e = document.createEvent('HTMLEvents');
	
	                e.initEvent(type, true, false);
	                el.dispatchEvent(e);
	                //console.log(e);
	            } else {
	                // IE 8
	                e = document.createEventObject();
	
	                e.eventType = type;
	                el.fireEvent('on' + e.eventType, e);
	            }
	        }
	
	        /**
	         * Query nodes from a selector and return an Array of nodes
	         *
	         *      du.queryAll('.main');
	         *      du.queryAll('.block', parentNode);
	         *
	         * @param {String} expr Selector to query on the dom
	         * @param {HTMLElement} container An optional parent Node from the query
	         * @return {HTMLElement[]} Nodes Array of queryed nodes
	         */
	
	    }, {
	        key: 'queryAll',
	        value: function queryAll(expr, container) {
	            return Array.prototype.slice.call((container || document).querySelectorAll(expr));
	        }
	
	        /**
	         * Toggle html attribute boolean string
	         *
	         *      du.toggleAttribute(node, 'aria-expanded');
	         *
	         * @param {HTMLElement} The node to apply toggling
	         * @param {String} The html attribute name
	         * @return {String} The new attribute string
	         */
	
	    }, {
	        key: 'toggleAttribute',
	        value: function toggleAttribute(node, attribute) {
	            var oldvalue = this.parseBoolean(node.getAttribute(attribute));
	            var newValue = !oldvalue + '';
	            node.setAttribute(attribute, newValue);
	            return newValue;
	        }
	
	        /**
	         * Parse string to boolean
	         *
	         *      du.parseBoolean('true');
	         *      du.parseBoolean('false');
	         *
	         * @param {String} The string to parse
	         * @return {Boolean} The converted boolean
	         */
	
	    }, {
	        key: 'parseBoolean',
	        value: function parseBoolean(attribute) {
	            return 'true' === attribute;
	        }
	
	        /* eslint-disable max-statements, max-depth */
	        /**
	         * Get closest DOM element up the tree that contains a class, ID, data attribute, or tag.
	         * Includes the element itself. Supported back to IE6.
	         * Source : http://gomakethings.com/ditching-jquery#climb-up-the-dom
	         * @static
	         * @param {HTMLElement} elem
	         * @param {String} selector
	         * @returns HTMLElement or null
	         *
	         * @memberOf du
	         */
	
	    }, {
	        key: 'getClosest',
	        value: function getClosest(elem, selector) {
	            // Variables
	            var firstChar = selector.charAt(0);
	            var supports = 'classList' in document.documentElement;
	            var attribute, value;
	            // If selector is a data attribute, split attribute from value
	            if (firstChar === '[') {
	                selector = selector.substr(1, selector.length - 2);
	                attribute = selector.split('=');
	                if (attribute.length > 1) {
	                    value = true;
	                    attribute[1] = attribute[1].replace(/"/g, '').replace(/'/g, '');
	                }
	            }
	            // Get closest match
	            for (; elem && elem !== document && elem.nodeType === 1; elem = elem.parentNode) {
	                // If selector is a class
	                if (firstChar === '.') {
	                    if (supports) {
	                        if (elem.classList.contains(selector.substr(1))) {
	                            return elem;
	                        }
	                    } else {
	                        if (new RegExp('(^|\\s)' + selector.substr(1) + '(\\s|$)').test(elem.className)) {
	                            return elem;
	                        }
	                    }
	                }
	                // If selector is an ID
	                if (firstChar === '#') {
	                    if (elem.id === selector.substr(1)) {
	                        return elem;
	                    }
	                }
	                // If selector is a data attribute
	                if (firstChar === '[') {
	                    if (elem.hasAttribute(attribute[0])) {
	                        if (value) {
	                            if (elem.getAttribute(attribute[0]) === attribute[1]) {
	                                return elem;
	                            }
	                        } else {
	                            return elem;
	                        }
	                    }
	                }
	                // If selector is a tag
	                if (elem.tagName.toLowerCase() === selector) {
	                    return elem;
	                }
	            }
	            return null;
	        }
	        /* eslint-enable max-statements, max-depth */
	
	        /**
	         *  take a list of elements and add class on touchstart event on each element
	         * @param {HTMLElement} elems - a list of elements.
	         * @param {String} cssClass - the added css class
	         */
	
	    }, {
	        key: 'hoverOnScrollForMobile',
	        value: function hoverOnScrollForMobile(elems, cssClass) {
	            elems.forEach(function (elem) {
	                du.onEvent(elem, 'touchstart', function () {
	                    elem.classList.add(cssClass);
	                });
	
	                du.onEvent(elem, 'touchend', function () {
	                    elem.classList.remove(cssClass);
	                });
	            });
	        }
	    }]);
	
	    return du;
	}();
	
	exports.default = du;
	;

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AjaxSvg = function () {
	    function AjaxSvg() {
	        _classCallCheck(this, AjaxSvg);
	
	        this.request = new XMLHttpRequest();
	    }
	
	    _createClass(AjaxSvg, [{
	        key: 'init',
	        value: function init(svgPath) {
	            this.request.open('GET', svgPath, true);
	            this.request.send();
	            this.request.onload = this._onload;
	        }
	    }, {
	        key: '_onload',
	        value: function _onload() {
	            document.body.insertAdjacentHTML('afterbegin', this.responseText);
	        }
	    }]);
	
	    return AjaxSvg;
	}();
	
	exports.default = AjaxSvg;
	;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _ScrollTo = __webpack_require__(7);
	
	var _ScrollTo2 = _interopRequireDefault(_ScrollTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ScrollToTop = function () {
	    function ScrollToTop() {
	        _classCallCheck(this, ScrollToTop);
	    }
	
	    _createClass(ScrollToTop, [{
	        key: 'init',
	        value: function init(selector) {
	            _domUtilities2.default.queryAll(selector).forEach(function (elem) {
	                _domUtilities2.default.onEvent(elem, 'click', function (event) {
	                    event.preventDefault();
	                    (0, _ScrollTo2.default)(document.scrollingElement || document.documentElement, 0, 400);
	                });
	            });
	        }
	    }]);
	
	    return ScrollToTop;
	}();
	
	exports.default = ScrollToTop;
	;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rafPolyfill = __webpack_require__(3);
	
	var _rafPolyfill2 = _interopRequireDefault(_rafPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// easing functions http://goo.gl/5HLl8
	var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
	  t /= d / 2;
	  if (t < 1) {
	    return c / 2 * t * t + b;
	  }
	  t--;
	  return -c / 2 * (t * (t - 2) - 1) + b;
	};
	
	var scrollTo = function scrollTo(element, to) {
	  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 400;
	  var callback = arguments[3];
	
	  var start = element.scrollTop,
	      change = to - start,
	      currentTime = 0,
	      increment = 10;
	
	  var animateScroll = function animateScroll() {
	    currentTime += increment;
	    element.scrollTop = easeInOutQuad(currentTime, start, change, duration);
	
	    if (currentTime < duration) {
	      (0, _rafPolyfill2.default)(animateScroll);
	    } else {
	      if (callback && typeof callback === 'function') {
	        callback();
	      }
	    }
	  };
	  animateScroll();
	};
	
	exports.default = scrollTo;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = init;
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Display a "back to top" button in the interface right margin.
	 *
	 * @param  {Null}
	 * @return {Set|Listenner} - Set classes onscroll to show or hide the "buttonBackToTop" HTMLElement.
	 */
	function init() {
	    var buttonBackToTop = document.querySelector('.button-backtotop.js-back-to-top');
	
	    if (!_domUtilities2.default.isElement(buttonBackToTop)) {
	        console.error('"buttonBackToTop" must be a valid HTMLElement');
	
	        return;
	    }
	
	    var headerBannerHeight = document.querySelector('header[role="banner"]').getBoundingClientRect().height;
	    var visible = 'state--visible';
	    var watermark = 'state--visible--watermark';
	    var hidden = 'state--hidden';
	
	    _domUtilities2.default.onEvent(window, 'optimized-scroll', _domUtilities2.default.setThrottle(function () {
	        var scrollTopPosition = document.body.scrollTop || document.documentElement.scrollTop;
	        var scrollCue = scrollTopPosition >= headerBannerHeight / 1.5;
	
	        if (scrollCue) {
	            _domUtilities2.default.setClass(buttonBackToTop, visible);
	
	            _domUtilities2.default.unsetClass(buttonBackToTop, hidden);
	            _domUtilities2.default.unsetClass(buttonBackToTop, watermark);
	
	            if (scrollTopPosition >= headerBannerHeight * 1.5) {
	                _domUtilities2.default.setClass(buttonBackToTop, watermark);
	
	                _domUtilities2.default.unsetClass(buttonBackToTop, visible);
	            }
	        }
	
	        if (!scrollCue) {
	            _domUtilities2.default.setClass(buttonBackToTop, hidden);
	
	            _domUtilities2.default.unsetClass(buttonBackToTop, visible);
	            _domUtilities2.default.unsetClass(buttonBackToTop, watermark);
	        }
	    }, 500));
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (pageSelector, bottomSelector) {
	    var page = document.querySelector(pageSelector),
	        bottom = document.querySelector(bottomSelector);
	
	    if (page !== null && bottom !== null) {
	        _checkMq(page, bottom);
	
	        _domUtilities2.default.onEvent(window, 'load', function () {
	            // Called a second time at load
	            _checkMq(page, bottom);
	        });
	
	        _domUtilities2.default.onEvent(window, 'optimized-resize', function () {
	            _checkMq(page, bottom);
	        });
	    }
	};
	
	var _conf = __webpack_require__(1);
	
	var _conf2 = _interopRequireDefault(_conf);
	
	var _Utils = __webpack_require__(10);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Calc bottom height and apply margin at the page
	 *
	 * @param {HTMLElement} page
	 * @param {HTMLElement} bottom
	 */
	function _defineMargin(page, bottom) {
	    var style = bottom.getBoundingClientRect();
	    page.style.marginBottom = (parseInt(style.height) || 0) + 'px';
	}
	
	/**
	 * Unset margin at page
	 *
	 * @param {HTMLElement} page
	 */
	function _undefineMargin(page) {
	    page.style.marginBottom = '0px';
	}
	
	/**
	 * Check window width and define the margin bottom
	 *
	 * @param {HTMLElement} page
	 * @param {HTMLElement} bottom
	 */
	function _checkMq(page, bottom) {
	    if (Modernizr.mq('(min-width: ' + _Utils2.default.em(_conf2.default.mq.lg) + 'em)')) {
	        _defineMargin(page, bottom);
	    } else {
	        _undefineMargin(page);
	    }
	}
	
	/**
	 * Apply bottom effect at a page depends of his bottom
	 *
	 * @export
	 * @param {string} pageSelector
	 * @param {string} bottomSelector
	 */
	;

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Utils = function () {
	    function Utils() {
	        _classCallCheck(this, Utils);
	    }
	
	    _createClass(Utils, null, [{
	        key: "em",
	        value: function em(pxValue) {
	            return (parseInt(pxValue) || 0) / 16;
	        }
	    }]);
	
	    return Utils;
	}();
	
	exports.default = Utils;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Lightbox = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _lightboxTpl = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Lightbox Class
	 *
	 * @export
	 * @class Lightbox
	 */
	var Lightbox = exports.Lightbox = function () {
	
	    /**
	     * Create an instance of lightbox.
	     *
	     * @param {string} id an optional id for the dom lightbox
	     * @param {string} label an optional label for the close button
	     * @memberOf Lightbox
	     */
	    function Lightbox() {
	        var _this = this;
	
	        var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lightbox';
	        var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Fermer';
	
	        _classCallCheck(this, Lightbox);
	
	        if (document.getElementById(id)) {
	            console.error('Element with id: "' + id + '" already exist on the DOM');
	        }
	        document.querySelector('body').insertAdjacentHTML('beforeend', (0, _lightboxTpl.lightboxTpl)(id, label));
	
	        this.lightbox = document.getElementById(id);
	        this.content = this.lightbox.querySelector('.js-lightbox-content');
	        this.modifierCssClass = [];
	
	        // Elements that trigger a closing of the lightbox.
	        _domUtilities2.default.queryAll('.js-lightbox-close', this.lightbox).forEach(function (elem) {
	            _domUtilities2.default.onEvent(elem, 'click', function (evt) {
	                evt.preventDefault();
	                _this.close();
	            });
	        });
	
	        document.onkeydown = function (evt) {
	            evt = evt || window.event;
	            var isEscape = false;
	            if ('key' in evt) {
	                isEscape = evt.key === 'Escape' || evt.key === 'Esc';
	            } else {
	                isEscape = evt.keyCode === 27;
	            }
	            if (isEscape) {
	                _this.close();
	            }
	        };
	    }
	
	    /**
	     * Function to close the lightbox
	     *
	     * @memberOf Lightbox
	     */
	
	
	    _createClass(Lightbox, [{
	        key: 'close',
	        value: function close() {
	            var _this2 = this;
	
	            _domUtilities2.default.setClass(this.lightbox, 'lightbox--off');
	            _domUtilities2.default.unsetClass(document.querySelector('html'), 'documentScrollHidden');
	
	            window.setTimeout(function () {
	                _this2.content.innerHTML = '';
	
	                _domUtilities2.default.unsetClass(_this2.lightbox, 'lightbox--on');
	                _domUtilities2.default.unsetClass(_this2.lightbox, 'lightbox--off');
	
	                if (_this2.modifierCssClass.length) {
	                    _this2.modifierCssClass.forEach(function (cssClass) {
	                        _domUtilities2.default.unsetClass(_this2.lightbox, cssClass);
	                    });
	                    _this2.modifierCssClass = [];
	                }
	            }, 200); // Time in milliseconds, synched to CSS animation.
	        }
	
	        /**
	         * Function to open lightbox
	         *
	         * @param {Array} modifierCssClass Array of {string} css class for lightbox
	         * @memberOf Lightbox
	         */
	
	    }, {
	        key: 'open',
	        value: function open() {
	            var _this3 = this;
	
	            var modifierCssClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (Array.isArray(modifierCssClass)) {
	                this.modifierCssClass = modifierCssClass;
	                this.modifierCssClass.forEach(function (cssClass) {
	                    _domUtilities2.default.setClass(_this3.lightbox, cssClass);
	                });
	            }
	            _domUtilities2.default.setClass(document.querySelector('html'), 'documentScrollHidden');
	            _domUtilities2.default.setClass(this.lightbox, 'lightbox--on');
	        }
	
	        /**
	         * Insert html data string in content
	         *
	         * @param {string} data htmlstring to insert
	         * @returns {HTMLElement} of content
	         * @memberOf Lightbox
	         */
	
	    }, {
	        key: 'insertData',
	        value: function insertData(data) {
	            this.content.innerHTML = data;
	            return this.content;
	        }
	    }]);
	
	    return Lightbox;
	}();
	
	;

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * @export
	 * @function
	 * @param {string} id An optional custom id
	 * @param {string} label An optional label for the close button
	 * @return {string}
	 */
	var lightboxTpl = exports.lightboxTpl = function lightboxTpl() {
	    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lightbox';
	    var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Fermer';
	
	    return '<div id="' + id + '" class="lightbox">\n                <div class="lightbox__scroll">\n                    <div class="lightbox__bg js-lightbox-close"></div>\n                    <div class="lightbox__scroll-inner">\n                        <div class="lightbox__container">\n                            <div class="lightbox__content js-lightbox-content"></div>\n                            <button type="button" class="lightbox__close-button js-lightbox-close">\n                                <span class="lightbox__close-text">' + label + '</span>\n                                <svg class="lightbox__close-icon ico ico--close">\n                                    <use xlink:href="#close"/>\n                                </svg>\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </div>';
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = sliderLightbox;
	
	var _slider = __webpack_require__(14);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _sliderTpl = __webpack_require__(16);
	
	var _sliderTpl2 = _interopRequireDefault(_sliderTpl);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get data from DOM and return array of object
	 *
	 * @param {HTMLElement} sliderLightbox - A sliderLightbox node
	 * @return {Object[]} data to insert
	 */
	function _getDataFromListImage(sliderLightbox) {
	    var sliders = _domUtilities2.default.queryAll('.js-slider-lightbox-item', sliderLightbox);
	
	    return sliders.map(function (elem, index) {
	        return {
	            src: elem.querySelector('img').src,
	            srcset: elem.querySelector('img').getAttribute('data-slider-srcset'),
	            sizes: elem.querySelector('img').getAttribute('data-slider-sizes'),
	            alt: elem.querySelector('img').alt,
	            description: elem.querySelector('.js-slider-text-description').innerHTML,
	            copyright: elem.querySelector('.js-slider-text-copyright').innerHTML,
	            signature: elem.querySelector('.js-slider-text-signature').innerHTML,
	            totalSlides: sliders.length,
	            currentSlide: index + 1
	        };
	    });
	}
	
	/**
	 * Init a slider-lightbox
	 * @param {Lightbox} lightbox - The lightbox instance of the site
	 */
	function sliderLightbox(lightbox) {
	    var options = {
	        moduleSelector: '.slider-lightbox',
	        itemSelector: '.js-load-lightbox'
	    };
	
	    _domUtilities2.default.queryAll(options.moduleSelector).forEach(function (sliderLightboxModule) {
	        _domUtilities2.default.queryAll(options.itemSelector, sliderLightboxModule).forEach(function (sliderLightboxItem, index) {
	            _domUtilities2.default.onEvent(sliderLightboxItem, 'click', function () {
	                var listData = _getDataFromListImage(sliderLightboxModule);
	                var content = lightbox.insertData((0, _sliderTpl2.default)(listData));
	                var sliderModule = content.querySelector('[data-slider-module]');
	
	                var sliderObject = (0, _slider2.default)(sliderModule, index);
	                lightbox.open(['lightbox--dark']);
	                // Hack to fix slider init position when % width is used
	                sliderObject.slider.slider.reset();
	                sliderObject.slider.slider.slideTo(index);
	            });
	
	            _domUtilities2.default.onEvent(sliderLightboxItem, 'touchstart', function () {
	                sliderLightboxItem.classList.add('is--touched');
	            });
	
	            _domUtilities2.default.onEvent(sliderLightboxItem, 'touchend', function () {
	                sliderLightboxItem.classList.remove('is--touched');
	            });
	        });
	    });
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = slider;
	exports.initSliders = initSliders;
	
	var _lory = __webpack_require__(15);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Synchronize Two Slider Together
	 *
	 * @param {HTMLElement} el - The slider element
	 * @param {lory} source - The slider lory object
	 * @param {lory} target - The slider lory object to sync with
	 * @param {HTMLElement} desc - The desc element
	 */
	function _syncSliders(el, source, target, desc) {
	    el.addEventListener('after.lory.slide', function (thatEvt) {
	        var sourceIndex = source.returnIndex();
	        var targetIndex = target.returnIndex();
	
	        thatEvt.stopPropagation();
	
	        if (sourceIndex !== targetIndex) {
	            target.slideTo(sourceIndex);
	            _showDesc(desc, sourceIndex);
	        }
	    });
	}
	
	/**
	 * Show desc elemnt
	 *
	 * @param {HTMLElement} desc - The slider descpription node
	 * @param {Number} index - The index to show
	 */
	function _showDesc(desc) {
	    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	    _domUtilities2.default.queryAll('[data-slider-descindex]', desc).forEach(function (elem) {
	        if (parseInt(elem.getAttribute('data-slider-descindex')) === index) {
	            elem.classList.add('state--active');
	        } else {
	            elem.classList.remove('state--active');
	        }
	    });
	}
	
	/**
	 * Change Slide On Click
	 *
	 * @param {HTMLElement} el
	 * @param {lory} target
	 * @param {String} slideclass
	 */
	function _changeSlideOnClick(el, target, slideclass) {
	    var _isNavigating = false;
	
	    el.addEventListener('click', function (thatEvt) {
	        if (_isNavigating) {
	            thatEvt.preventDefault();
	            thatEvt.stopPropagation();
	
	            return false;
	        }
	
	        if (_domUtilities2.default.hasClass(thatEvt.target, slideclass)) {
	            target.slideTo(parseInt(thatEvt.target.getAttribute('data-slider-controlindex')));
	        }
	
	        return true;
	    });
	
	    el.addEventListener('on.lory.touchstart', function (thatEvt) {
	        _isNavigating = true;
	
	        thatEvt.stopPropagation();
	        thatEvt.preventDefault();
	    });
	
	    el.addEventListener('on.lory.touchmove', function (thatEvt) {
	        _isNavigating = true;
	
	        thatEvt.stopPropagation();
	        thatEvt.preventDefault();
	    });
	
	    el.addEventListener('on.lory.touchend', function () {
	        _isNavigating = !_isNavigating;
	    });
	
	    el.addEventListener('before.lory.slide', function (thatEvt) {
	        _isNavigating = true;
	
	        thatEvt.stopPropagation();
	        thatEvt.preventDefault();
	    });
	
	    el.addEventListener('after.lory.slide', function () {
	        _isNavigating = !_isNavigating;
	    });
	}
	
	/**
	 * Slider
	 *
	 * @export
	 * @param {HTMLElement} content Slider module
	 * @param {Number} start Index to start the slider slides
	 * @param {Boolean} resetOnLoad To seset the main slider after window load (To prevent visual bug, on slider width 100%)
	 * @param {Number} max Maximum of visible controls slides
	 */
	/* eslint-disable max-statements */
	function slider(content) {
	    var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var resetOnLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    var max = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 5;
	
	    if (!_domUtilities2.default.isElement(content)) {
	        console.error('"content" argument must be a valid HTMLElement');
	        return;
	    }
	
	    var sliderEl = content.querySelector('.js-slider-slider');
	    var controlsEl = sliderEl.parentNode.querySelector('.js-slider-controls');
	    var descEl = content.querySelector('.js-slider-desc');
	
	    var frameClass = 'js-slider-frame';
	    var slidesClass = 'js-slider-slides';
	    var slideClass = 'js-slider-slide';
	
	    var sliderSlides = _domUtilities2.default.queryAll('.' + slideClass, sliderEl);
	
	    var slider = (0, _lory.lory)(sliderEl, {
	        infinite: 1,
	        classNameFrame: frameClass,
	        classNameSlideContainer: slidesClass
	    });
	
	    var controls = (0, _lory.lory)(controlsEl, {
	        infinite: sliderSlides.length <= max ? sliderSlides.length : max,
	        classNameFrame: frameClass,
	        classNameSlideContainer: slidesClass,
	        enableMouseEvents: true
	    });
	
	    content.classList.add(sliderSlides.length <= max ? 'slider--has-' + sliderSlides.length + '-slides' : 'slider--has-a-lot-slides');
	
	    if (resetOnLoad) {
	        _domUtilities2.default.onEvent(window, 'load', function () {
	            slider.reset();
	        });
	    }
	    // The Slider and the Controls Must Be Synchronize
	    _syncSliders(sliderEl, slider, controls, descEl);
	    _syncSliders(controlsEl, controls, slider, descEl);
	
	    _showDesc(descEl, start);
	    slider.slideTo(start);
	
	    _changeSlideOnClick(controlsEl, slider, slideClass);
	
	    return {
	        'slider': {
	            slider: slider,
	            sliderEl: sliderEl
	        },
	        'controls': {
	            controls: controls,
	            controlsEl: controlsEl
	        }
	    };
	};
	/* eslint-enable max-statement */
	
	/**
	 * Init slider with the given selector
	 *
	 * @param {String} cssSelector
	 */
	function initSliders(cssSelector) {
	    return _domUtilities2.default.queryAll(cssSelector).map(function (elem) {
	        return slider(elem, 0, true);
	    });
	};

/***/ },
/* 15 */,
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * @export
	 * @function
	 * @param {Object} data - Slide data
	 * @return {string}
	 */
	var sliderTextTpl = exports.sliderTextTpl = function sliderTextTpl(data, index) {
	
	    var copyright = '';
	    if (data.copyright && data.signature) {
	        copyright = '<p class="slider__desc__copyright"> ' + data.copyright + ' </p>\n                     <p class="slider__desc__signature"> ' + data.signature + ' </p>';
	    }
	    return '<div class="slider__desc__slide row" data-slider-descindex="' + index + '">\n                <div class="col-12">\n                    <p class="slider__desc__pager">\n                        <span class=\'slider__desc__pager-current\'>' + data.currentSlide + '</span> /\n                        <span class=\'slider__desc__pager-total\'>' + data.totalSlides + '</span>\n                    </p>\n                </div>\n                <div class="col-12 col-sm-6 slider__desc__left content-zone">\n                    ' + (data.description || '') + '\n                </div>\n                <div class="col-12 col-sm-4 col-sm-offset-2 slider__desc__right">\n                    ' + copyright + '\n                </div>\n            </div>';
	};
	
	/**
	 * @export
	 * @function
	 * @param {Object[]} data List of slides data
	 * @return {string}
	 */
	var sliderTextContainerTpl = exports.sliderTextContainerTpl = function sliderTextContainerTpl(data) {
	    return '<div class="slider__desc js-slider-desc">\n                ' + data.map(function (elem, index) {
	        return sliderTextTpl(elem, index);
	    }).join('') + '\n            </div>';
	};
	
	/**
	 * Slide of main slider
	 *
	 * @export
	 * @function
	 * @param {string} source src attribute
	 * @param {string} srcset srcset attribute
	 * @param {string} sizes sizes attribute
	 * @param {string} alt alt attribute
	 * @return {string}
	 */
	var listItemTpl = exports.listItemTpl = function listItemTpl(source, srcset, sizes, alt) {
	    return '<li class="slider__item js-slider-slide">\n                <img class="slider__item-img" src="' + source + '" srcset="' + srcset + '" sizes="' + sizes + '" alt="' + alt + '"/>\n            </li>';
	};
	
	/**
	 * Slide of controller slider
	 *
	 * @export
	 * @function
	 * @param {string} source src attribute
	 * @param {string} alt alt attribute
	 * @param {Number} index Index value for the data-slider-controlindex attribute
	 * @return {string}
	 */
	var listItemControllerTpl = exports.listItemControllerTpl = function listItemControllerTpl(source, alt, index) {
	    return '<li class="slider__controls__item js-slider-slide" data-slider-controlindex="' + index + '">\n                <img src="' + source + '" alt="' + alt + '"/>\n            </li>';
	};
	
	/**
	 * @export
	 * @function
	 * @param {Object[]} data Suite of slidesTpl string
	 * @return {string}
	 */
	var sliderMainTpl = exports.sliderMainTpl = function sliderMainTpl(data) {
	    return '<div class="slider__slider js-slider-slider">\n                <div class="slider__frame js-slider-frame">\n                    <ul class="slider__slides js-slider-slides">\n                        ' + data.map(function (elem) {
	        return listItemTpl(elem.src, elem.srcset, elem.sizes, elem.alt);
	    }).join('') + '\n                    </ul>\n                </div>\n                <button class="js_prev prev">\n                    <svg class="ico ico--chevron-left" width="50" height="50"><use xlink:href="#chevron-left"/></svg>\n                </button>\n                <button class="js_next next">\n                    <svg class="ico ico--chevron-right" width="50" height="50"><use xlink:href="#chevron-right"/></svg>\n                  </button>\n            </div>';
	};
	
	/**
	 * @export
	 * @function
	 * @param {Object[]} data Data of slides
	 * @return {string}
	 */
	var sliderControllerTpl = exports.sliderControllerTpl = function sliderControllerTpl(data) {
	    return '<div class="slider__controls js-slider-controls">\n                <div class="slider__controls__frame js-slider-frame">\n                    <ul class="slider__controls__slides js-slider-slides">\n                        ' + data.map(function (elem, index) {
	        return listItemControllerTpl(elem.src, elem.alt, index);
	    }).join('') + '\n                    </ul>\n                </div>\n            </div>';
	};
	
	/**
	 * Slider module (main slider and controller)
	 *
	 * @export
	 * @default
	 * @function
	 * @param {Object[]} data List of slides data
	 * @return {string}
	 */
	var sliderModule = function sliderModule(data) {
	    return '<div class="slider" data-slider-module>\n                <div class="slider__wrap">\n                    ' + sliderMainTpl(data) + '\n                    ' + sliderControllerTpl(data) + '\n                </div>\n                ' + sliderTextContainerTpl(data) + '\n            </div>';
	};
	
	exports.default = sliderModule;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var domElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var offsetHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var activeClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	    var bodyClass = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	    var body = document.body;
	
	    window.addEventListener('optimized-scroll', function () {
	        if (window.innerWidth > limit) {
	            if (window.pageYOffset >= offsetHeight - 50) {
	                // Add 50px to make fixed transition smoother on chromium
	                _domUtilities2.default.setClass(domElement, activeClass);
	                if (bodyClass) {
	                    if (!body.classList.contains(bodyClass)) {
	                        _domUtilities2.default.setClass(body, bodyClass);
	                    }
	                }
	
	                if (!domElement.classList.contains(activeClass)) {
	                    _domUtilities2.default.setClass(domElement, activeClass);
	                }
	            } else {
	                _domUtilities2.default.unsetClass(domElement, activeClass);
	                if (bodyClass) {
	                    if (domElement.classList.contains(activeClass)) {
	                        _domUtilities2.default.setClass(domElement, activeClass);
	                    }
	
	                    if (body.classList.contains(bodyClass)) {
	                        _domUtilities2.default.unsetClass(body, bodyClass);
	                    }
	                }
	            }
	        }
	    });
	};
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	
	/**
	 * Anonymous - Add listenner on scroll on domElement
	 *
	 * @param  {HTMLElement} [domElement=null] - Desired DOM element
	 * @param  {Number} [offsetHeight=0]  - Desired offsetHeight
	 * @param  {String} [activeClass='']  - Classname to add when offsetHeight is achieve
	 * @param  {Number} [limit=false] - Define window width limit
	 * @return {Set|Listenner} - Set sticky state on init and on scroll
	 */

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.setScrollTo = exports.getMenuLimit = exports.Anchors = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lory = __webpack_require__(15);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _ScrollTo = __webpack_require__(7);
	
	var _ScrollTo2 = _interopRequireDefault(_ScrollTo);
	
	var _isScrolledIntoView = __webpack_require__(19);
	
	var _isScrolledIntoView2 = _interopRequireDefault(_isScrolledIntoView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * setScrollTo - Animate scroll to node
	 *
	 * @param {HTMLElement} [destinationNode=null] - desintation scroll to node
	 */
	var setScrollTo = function setScrollTo() {
	    var destinationNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    if (!destinationNode) {
	        return;
	    }
	
	    var bodyRect = document.body.getBoundingClientRect();
	    var destinationRect = destinationNode.getBoundingClientRect();
	    var offset = destinationRect.top - (bodyRect.top - 10);
	
	    (0, _ScrollTo2.default)(document.scrollingElement || document.documentElement, offset, 400);
	};
	
	/**
	 * getMenuLimit - Get anchors Menu Width
	 *
	 * @param  {HTMLElement} [anchorsItems=null] - DOM nodes of anchors
	 * @return {Number} - Anchors menu width
	 */
	var getMenuLimit = function getMenuLimit() {
	    var menu = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    if (!menu) {
	        throw new Error('menu param cannot be null');
	    }
	
	    menu = document.querySelector(menu);
	    var container = _domUtilities2.default.getClosest(menu, '.container');
	
	    if (!menu) {
	        return;
	    }
	
	    if (!container) {
	        return menu.offsetWidth;
	    }
	
	    var menuItemsWidth = menu.offsetWidth;
	    menuItemsWidth += parseFloat(window.getComputedStyle(container).getPropertyValue('padding-left'));
	    menuItemsWidth += parseFloat(window.getComputedStyle(container).getPropertyValue('padding-right'));
	
	    return menuItemsWidth;
	};
	
	/* eslint-disable max-statements */
	
	var Anchors = function () {
	    function Anchors() {
	        _classCallCheck(this, Anchors);
	
	        this._anchors = [];
	        this._isNavigating = false;
	    }
	
	    /**
	     * init - Get anchors template based on anchors DOM Tree
	     *
	     * @param  {String} [elements='.anchor__content'] - DOM node selector
	     * @return {HTMLElement}
	     */
	
	
	    _createClass(Anchors, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (!elements || !target) {
	                throw new Error('elements param or target param cannot be null.');
	            }
	
	            var domAnchors = _domUtilities2.default.queryAll(elements);
	            target = document.querySelector(target);
	
	            if (!domAnchors || !target) {
	                return; // Silent error
	            }
	
	            domAnchors.forEach(function (anchor) {
	                _this._anchors.push(_this._buildAnchor(anchor));
	            });
	
	            target.innerHTML += this._buildAnchors(this._anchors);
	            var anchorsWrapper = document.querySelector('.js-anchors-wrapper');
	            this._setupAnchorSlider(anchorsWrapper, '.anchors__items', 'js-anchors--active');
	
	            document.body.classList.add('has-anchors');
	
	            this._toggleActiveClass();
	            this._setAnchorClickEvent(target);
	
	            var anchors = _domUtilities2.default.queryAll('.anchor__content');
	            if (anchors.length > 0) {
	                var href = anchors[0].getAttribute('id');
	                if (href) {
	                    document.querySelector('[href="#' + href + '"]').classList.add('anchors__link--active');
	                }
	            }
	        }
	
	        /**
	         * Add active class on anchor__link if DOM element has been scrolled
	         */
	
	    }, {
	        key: '_toggleActiveClass',
	        value: function _toggleActiveClass() {
	            var previous = window.scrollY;
	            _domUtilities2.default.onEvent(window, 'scroll', function () {
	                var anchors = _domUtilities2.default.queryAll('.anchor__content');
	                var scrollDirection = window.scrollY > previous ? 'down' : 'up';
	                previous = window.scrollY;
	
	                anchors.forEach(function (anchor, index) {
	
	                    if ((0, _isScrolledIntoView2.default)(anchor)) {
	                        if (scrollDirection === 'up' && index > 0) {
	                            anchor = anchors[index - 1];
	                        }
	
	                        var href = anchor.getAttribute('id');
	                        if (href) {
	                            var link = document.querySelector('[href="#' + href + '"]');
	
	                            if (!link.classList.contains('anchor__link--active')) {
	                                _domUtilities2.default.queryAll('.anchors__link').forEach(function (link) {
	                                    link.classList.remove('anchors__link--active');
	                                });
	                                link.classList.add('anchors__link--active');
	                            } else {
	                                link.classList.remove('anchors__link--active');
	                            }
	                        }
	                    }
	                });
	            });
	        }
	
	        /**
	         * buildAnchor - build an object with anchor details
	         *
	         * @param  {HTMLElement} [anchor=null] - anchor DOM element
	         * @return {Object} - Object with anchor details (value, isExternal, template)
	         */
	
	    }, {
	        key: '_buildAnchor',
	        value: function _buildAnchor() {
	            var anchor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!anchor) {
	                throw new Error('anchor object cannot be blank.');
	            }
	
	            var name = anchor.getAttribute('data-name');
	            var value = anchor.getAttribute('id') ? anchor.getAttribute('id') : anchor.getAttribute('data-url');
	            var isExternal = anchor.getAttribute('data-is-external');
	            var template = this._buildAnchorTemplate(name, value, isExternal);
	
	            return { name: name, value: value, isExternal: isExternal, template: template };
	        }
	
	        /**
	         * buildAnchors - build anchors markup
	         *
	         * @param  {Array}  [anchors=[]] - Array of anchor object
	         * @return {HTMLElement} return a template string  <ul><li><a>Anchor</a></li></ul>
	         */
	
	    }, {
	        key: '_buildAnchors',
	        value: function _buildAnchors() {
	            if (this._anchors.length <= 0) {
	                throw new Error('Anchors array cannot be empty.');
	            }
	
	            var template = this._separateAnchors(this._anchors);
	
	            return '<ul class="anchors__items">\n                    <li class="js-anchors-next">' + QUEBECOR_TRANSLATE.swipe + '</li>\n                    ' + template + '\n                </ul>';
	        }
	
	        /**
	         * separateAnchors - separate anchors by isExternal and build template
	         *
	         * @param  {Array}  [anchors=[]] - Array of anchor object
	         * @return {HTMLElement} return a template string  <li><a>Anchor</a></li>
	         */
	
	    }, {
	        key: '_separateAnchors',
	        value: function _separateAnchors() {
	            var anchors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	            var anchorsInner = anchors.filter(function (anchor) {
	                return anchor.isExternal === 'false';
	            }).map(function (anchor) {
	                return anchor.template;
	            }).join('');
	
	            var anchorsExternal = anchors.filter(function (anchor) {
	                return anchor.isExternal === 'true';
	            }).map(function (anchor) {
	                return anchor.template;
	            }).join('');
	
	            if (anchorsExternal === '') {
	                return '' + anchorsInner;
	            }
	
	            return anchorsInner + '\n            <li class="anchors__item anchors__item--external">\n                <ul class="anchors__items">' + anchorsExternal + '</ul>\n            </li>';
	        }
	
	        /**
	         * buildAnchorTemplate - build a template for a single anchor
	         *
	         * @param  {String}  [value=null] - value of Anchor
	         * @param  {String} [isExternal=false] - Is an external link or not
	         * @return {HTMLElement} return a template string - <li><a>Anchor</a></li>
	         */
	
	    }, {
	        key: '_buildAnchorTemplate',
	        value: function _buildAnchorTemplate() {
	            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var isExternal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'false';
	
	            if (!value || !name) {
	                throw new Error('name param or value param cannot be blank.');
	            }
	
	            if (isExternal === 'true') {
	                return '<li class="anchors__item anchor__item--external">\n                <a href="' + value + '" rel="external" class="anchors__link" target="_blank">\n                    ' + name + '\n                    <svg class="icon"><use xlink:href="#external"/></svg>\n                </a>\n            </li>';
	            }
	
	            return '<li class="anchors__item">\n            <a href="#' + value + '" class="anchors__link">' + name + '</a>\n        </li>';
	        }
	
	        /**
	         * setupAnchorSlider - Define slider for anchors menu
	         *
	         * @param  {HTMLElement} [anchorsWrapper=null] - Anchors wrapper DOM Node
	         * @param  {HTMLElement} [anchors=null] - DOM nodes of anchors
	         * @param  {HTMLElement} [container=null] - Container which wrap anchors
	         * @param  {String} [activeClass=null] - Active slider class
	         * @return {Set} set Lory slider instance
	         */
	
	    }, {
	        key: '_setupAnchorSlider',
	        value: function _setupAnchorSlider() {
	            var anchorsWrapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            var _this2 = this;
	
	            var anchors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	            var activeClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	            if (!anchorsWrapper || !anchors || !activeClass) {
	                return;
	            }
	
	            var loryOptions = {
	                enableMouseEvents: true,
	                classNameFrame: 'js-anchors-frame',
	                classNameSlideContainer: 'anchors__items',
	                slidesToScroll: 1
	            };
	
	            var anchorsParent = _domUtilities2.default.getClosest(anchorsWrapper, '.anchors');
	            var instance = (0, _lory.lory)(anchorsWrapper, loryOptions);
	
	            if (window.innerWidth <= getMenuLimit(anchors)) {
	                anchorsParent.classList.add(activeClass);
	                instance.setup();
	            } else {
	                instance.destroy();
	            }
	
	            _domUtilities2.default.onEvent(window, 'optimized-resize', function () {
	                if (window.innerWidth <= getMenuLimit(anchors)) {
	                    anchorsParent.classList.add(activeClass);
	                    instance.setup();
	                } else {
	                    anchorsParent.classList.remove(activeClass);
	                    instance.destroy();
	                }
	            });
	
	            anchorsWrapper.addEventListener('on.lory.touchstart', function (event) {
	                _this2._isNavigating = true;
	                event.preventDefault();
	                event.stopPropagation();
	            });
	
	            anchorsWrapper.addEventListener('on.lory.touchmove', function (event) {
	                _this2._isNavigating = true;
	                event.preventDefault();
	                event.stopPropagation();
	            });
	
	            anchorsWrapper.addEventListener('on.lory.touchend', function () {
	                _this2._isNavigating = !_this2._isNavigating;
	            });
	
	            anchorsWrapper.addEventListener('before.lory.slide', function (event) {
	                _this2._isNavigating = true;
	                event.preventDefault();
	                event.stopPropagation();
	            });
	
	            anchorsWrapper.addEventListener('after.lory.slide', function () {
	                _this2._isNavigating = !_this2._isNavigating;
	            });
	        }
	
	        /**
	         * setAnchorClickEvent - Set click event on anchor link
	         *
	         * @param {HTMLElement} [target=null] - Anchor link DOM element
	         */
	
	    }, {
	        key: '_setAnchorClickEvent',
	        value: function _setAnchorClickEvent() {
	            var _this3 = this;
	
	            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!target) {
	                throw new Error('target param cannot be empty');
	            }
	
	            _domUtilities2.default.queryAll('.anchors__link:not([rel="external"])').forEach(function (item) {
	
	                _domUtilities2.default.onEvents(item, 'click onTouchStart', function (event) {
	                    if (_this3._isNavigating) {
	                        event.preventDefault();
	                        event.stopPropagation();
	                        return false;
	                    }
	
	                    var linkHref = event.target.getAttribute('href');
	
	                    if (!linkHref) {
	                        return;
	                    }
	
	                    var destinationNode = document.querySelector(linkHref);
	
	                    if (!destinationNode) {
	                        return;
	                    }
	
	                    event.target.classList.add('anchor__link-is--active');
	
	                    history.pushState(null, null, linkHref);
	
	                    setScrollTo(destinationNode);
	                });
	            });
	        }
	    }]);
	
	    return Anchors;
	}();
	/* eslint-enable max-statements */
	
	
	exports.Anchors = Anchors;
	exports.getMenuLimit = getMenuLimit;
	exports.setScrollTo = setScrollTo;

/***/ },
/* 19 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = isScrolledIntoView;
	/**
	 * isScrolledIntoView - detect if element is in view
	 *
	 * @param  {HTMLElement}  el - DOM element which is supposed to be in view
	 * @return {Boolean} return true or false based of DOM element visibility in view
	 */
	function isScrolledIntoView() {
	    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    if (!el) {
	        return;
	    }
	
	    var boundingClient = el.getBoundingClientRect();
	
	    var elemTop = boundingClient.top;
	    var elemBottom = boundingClient.bottom;
	
	    var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight / 2;
	    return isVisible;
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lory = __webpack_require__(15);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _anchor = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * initNavigationSwipe - Init third level menu -
	 * Create or destroy a Lory instance
	 * @export
	 * @function
	 * @param  {String} [target=null] - DOM target string
	 * @return {Object[]} slider - The Lory slider instance
	 */
	var initNavigationSwipe = function initNavigationSwipe() {
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    if (!target) {
	        return;
	    }
	
	    return _domUtilities2.default.queryAll(target).map(function (DOMTarget) {
	
	        var options = {
	            enableMouseEvents: true,
	            classNameFrame: 'js-navigation-swipe-frame',
	            classNameSlideContainer: 'js-navigation-swipe-items',
	            infinite: false
	        };
	
	        var menu = '.navigation-swipe__items';
	        var slider = (0, _lory.lory)(DOMTarget, options);
	        var padding = 40; // Add 40px to menu width
	
	        if (window.innerWidth < (0, _anchor.getMenuLimit)(menu) + padding) {
	            _domUtilities2.default.setClass(DOMTarget, 'navigation-swipe--active');
	            slider.setup();
	        } else {
	            _domUtilities2.default.unsetClass(DOMTarget, 'navigation-swipe--active');
	            slider.destroy();
	        }
	
	        _domUtilities2.default.onEvent(window, 'optimized-resize', function () {
	            if (window.innerWidth < (0, _anchor.getMenuLimit)(menu) + padding) {
	                _domUtilities2.default.setClass(DOMTarget, 'navigation-swipe--active');
	                slider.setup();
	            } else {
	                _domUtilities2.default.unsetClass(DOMTarget, 'navigation-swipe--active');
	                slider.destroy();
	            }
	        });
	
	        return slider;
	    });
	};
	
	exports.default = initNavigationSwipe;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lory = __webpack_require__(15);
	
	var _conf = __webpack_require__(1);
	
	var _conf2 = _interopRequireDefault(_conf);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * responsiveSwipeItem - Activate a swipe slider on a itemlist inside a defined breakpoint
	 * -- DOM exemple: <div data-responsive-swipe-item="md">...<Frame and container, see lory.js doc>...</div>
	 * @export
	 * @function
	 * @param {String} targetDataAttribute Data-attribute name, should have a mq value on dom (see conf.js).
	 * @return {Object[]} Array of lory.js slider object
	 */
	var initResponsiveSwipeItem = function initResponsiveSwipeItem() {
	    var targetDataAttribute = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-responsive-swipe-item';
	
	
	    return _domUtilities2.default.queryAll('[' + targetDataAttribute + ']').map(function (DOMTarget) {
	        var options = {
	            enableMouseEvents: true,
	            classNameFrame: 'js-responsiveSwipeItem-frame', // 'js-annual-report-list__frame',
	            classNameSlideContainer: 'js-responsiveSwipeItem-container', //'js-annual-report-list__items',
	            slidesToScroll: 1
	        };
	        var breakpointValue = DOMTarget.getAttribute(targetDataAttribute);
	
	        var slider = (0, _lory.lory)(DOMTarget, options);
	
	        window.innerWidth < _conf2.default.mq[breakpointValue] ? slider.setup() : slider.destroy(); //769
	
	        _domUtilities2.default.onEvent(window, 'optimized-resize', function () {
	            window.innerWidth < _conf2.default.mq[breakpointValue] ? slider.setup() : slider.destroy();
	        });
	
	        return slider;
	    });
	};
	
	exports.default = initResponsiveSwipeItem;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.initHeaderVideo = exports.scrollDown = undefined;
	
	var _ScrollTo = __webpack_require__(7);
	
	var _ScrollTo2 = _interopRequireDefault(_ScrollTo);
	
	var _conf = __webpack_require__(1);
	
	var _conf2 = _interopRequireDefault(_conf);
	
	var _Utils = __webpack_require__(10);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * scrollDown - ScrollDown to main-content
	 *
	 * @param  {HTMLelement} [element=null] - DOM node which activate scroll down
	 * @return {Set} - Scroll to main-content (#main)
	 */
	function scrollDown() {
	    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    if (!element) {
	        throw new Error('Element param cannot be null.');
	    }
	
	    var mainContent = document.querySelector('#main');
	    var mainContentOffset = mainContent.getBoundingClientRect().top;
	
	    element.addEventListener('click', function (event) {
	        event.preventDefault();
	
	        (0, _ScrollTo2.default)(document.scrollingElement || document.documentElement, mainContentOffset, 400);
	    });
	}
	
	/**
	 * controlVideo - Control video state (play or pause)
	 *
	 * @param  {HTNLelement} [video=null] - video DOM Node
	 * @param  {HTMLelement} [element=null] - video control DOM node
	 * @return {Set} - Set video state play or pause
	 */
	function controlVideo() {
	    var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    if (!video || !element) {
	        throw new Error('video param or element param cannot be null in controlVideo function.');
	    }
	
	    // Init video state
	    setVideoState(video);
	
	    // Add click event on video control
	    element.addEventListener('click', function (event) {
	        event.preventDefault();
	
	        var currentVideoState = getVideoState(video);
	
	        if (currentVideoState === 'paused') {
	            setVideoState(video);
	            updateVideoControl(element);
	        } else {
	            setVideoState(video, 'paused');
	            updateVideoControl(element);
	        }
	    });
	}
	
	/**
	 * getVideoState - return state of video param
	 *
	 * @param  {HTNLelement} [video=null] - Video DOM Node
	 * @return {String} return paused of played based on current video state
	 */
	function getVideoState() {
	    var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    if (!video) {
	        throw new Error('Video param cannot be null in getVideoState function.');
	    }
	
	    if (video.paused) {
	        return 'paused';
	    }
	
	    return 'played';
	}
	
	/**
	 * setVideoState - Update video state based on desired state passed in param
	 *
	 * @param {HTNLelement} [video=null] - Video DOM Node
	 * @param {String} [state='played'] - desired video state
	 * @return {Set} - set video state play of paused
	 */
	function setVideoState() {
	    var video = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'played';
	
	    if (!video) {
	        throw new Error('Video param cannot be null in setVideoState function.');
	    }
	
	    if (state === 'played') {
	        video.play();
	    } else {
	        video.pause();
	    }
	}
	
	/**
	 * updateVideoControl - update video control class based on desired state
	 *
	 * @param  {HTMLElement} [element=null] - video control button
	 * @return {[type]} toggle video control class
	 */
	function updateVideoControl() {
	    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    if (!element) {
	        throw new Error('Element param cannot be null in updateVideoControl function.');
	    }
	
	    if (element.classList.contains('hero__video-button--paused')) {
	        element.classList.remove('hero__video-button--paused');
	        element.classList.add('hero__video-button--played');
	    } else {
	        element.classList.remove('hero__video-button--played');
	        element.classList.add('hero__video-button--paused');
	    }
	}
	
	/**
	 * Return a String template for the video
	 * @param {String} poster
	 * @param {String} video
	 * @return {String}
	 */
	function videoTpl() {
	    var poster = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var video = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	    return '<video poster="' + poster + '"\n                style="opacity:0;transition:opacity 0.3s;" webkit-playsinline="true" playsinline="true"\n                autoplay muted loop preload data-header-video-video>\n                <source src="' + video + '" type="video/mp4">\n            </video>';
	}
	
	/**
	 * Return a String template for the video control
	 * @return {String}
	 */
	function controlTpl() {
	    return '<button data-header-video-control class="hero__video-button hero__video-button--paused">\n                <svg class="icon icon--paused"><use xlink:href="#round-pause"/></svg>\n                <svg class="icon icon--played"><use xlink:href="#round-play"/></svg>\n            </button>';
	}
	
	/**
	 * Insert video element on the given container and active polyfill
	 * @param {HTMLElement} videoContainer The container of video
	 * @return {HTMLElement} The video inserted
	 */
	function insertHeaderVideo(videoContainer) {
	    var videoTemplate = videoTpl(videoContainer.getAttribute('data-header-poster'), videoContainer.getAttribute('data-header-video'));
	    videoContainer.insertAdjacentHTML('beforeend', videoTemplate);
	    var video = videoContainer.querySelector('video');
	    window.objectFitPolyfill(video);
	    revealElement(video);
	    return video;
	}
	
	/**
	 * Insert video control on the given container
	 * @param {HTMLElement} controlContainer
	 * @return {HTMLElement} Inserted control
	 */
	function insertHeaderVideoControl(controlContainer) {
	    controlContainer.insertAdjacentHTML('beforeend', controlTpl());
	    return controlContainer.querySelector('[data-header-video-control]');
	}
	
	/**
	 * Reveal the video elemnt only after few second when objectFit is polyfilled
	 * To prevent visual bug of small video for browser don<t have objectFit support
	 * @param {HTMLElement} video
	 */
	function revealElement(video) {
	    if ('objectFit' in document.documentElement.style !== false) {
	        video.style.opacity = '1';
	    } else {
	        window.setTimeout(function () {
	            video.style.opacity = '1';
	        }, 2000);
	    }
	}
	
	/**
	 * Insert video and controller nodes at min given size, otherwise remove it
	 * @param {HTMLElement} videoContainer
	 * @param {HTMLElement} controlContainer
	 */
	function toggleHeaderVideo(videoContainer, controlContainer) {
	    var video = videoContainer.querySelector('[data-header-video-video]');
	    var videoControl = controlContainer.querySelector('[data-header-video-control]');
	    if (Modernizr.mq('(min-width: ' + _Utils2.default.em(_conf2.default.mq.smmin) + 'em)')) {
	        if (!video && !videoControl) {
	            video = insertHeaderVideo(videoContainer);
	            videoControl = insertHeaderVideoControl(controlContainer);
	            controlVideo(video, videoControl);
	        }
	    } else if (video && videoControl) {
	        videoContainer.removeChild(video);
	        controlContainer.removeChild(videoControl);
	    }
	}
	
	/**
	 * Init the conditonal insert of video on header, and check on resize
	 * @param {HTMLElement} videoContainer
	 * @param {HTMLElement} controlContainer
	 */
	function initHeaderVideo(videoContainer, controlContainer) {
	    toggleHeaderVideo(videoContainer, controlContainer);
	
	    _domUtilities2.default.onEvent(window, 'optimized-resize', function () {
	        toggleHeaderVideo(videoContainer, controlContainer);
	    });
	}
	
	exports.scrollDown = scrollDown;
	exports.initHeaderVideo = initHeaderVideo;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _conf = __webpack_require__(1);
	
	var _conf2 = _interopRequireDefault(_conf);
	
	var _Utils = __webpack_require__(10);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * [showElement description]
	 * @param  {[type]} element [class name of an element]
	 * @param  {[type]} parent  [element context]
	 */
	function showElement(element, parent) {
	    _domUtilities2.default.queryAll(element, parent).forEach(function (item) {
	        item.classList.remove('tab-quarterly__hide');
	        item.children[0].classList.remove('tab-quarterly__active');
	    });
	}
	
	/**
	* Activate or desactivate tab-quarterly buttons.
	* @param  {boolean} bool
	*/
	function desactivateButton(bool, parent) {
	    _domUtilities2.default.queryAll('.js-quarterly__button', parent).forEach(function (item) {
	        item.disabled = bool;
	    });
	}
	
	/**
	* Hide multiple element.
	* @param  {string} class name of an element
	* @param  {[type]} parent  [element context]
	*/
	function hideElement(element, parent) {
	    _domUtilities2.default.queryAll(element, parent).forEach(function (item) {
	        item.classList.add('tab-quarterly__hide');
	    });
	}
	
	/**
	 * define height
	 * @param  {[type]} parent context NodeList
	 */
	function defineHeight(parent) {
	    if (!Modernizr.mq('(min-width: ' + _Utils2.default.em(_conf2.default.mq.xs) + 'em)')) {
	        var containerSize = _domUtilities2.default.outerHeight(parent.querySelector('.tab-quarterly__button'));
	        containerSize += _domUtilities2.default.returnMaxOuterHeight('.tab-quarterly__container', parent);
	        _domUtilities2.default.queryAll('.tab-quarterly__containers', parent).forEach(function (item) {
	            item.style.height = containerSize + 'px';
	        });
	    } else {
	        _domUtilities2.default.queryAll('.tab-quarterly__containers', parent).forEach(function (item) {
	            item.removeAttribute('style');
	        });
	    }
	}
	
	/**
	 * Show or hide element of tab-quarterly depending screen size.
	 * @param  {[type]} parent  [element context]
	 */
	function buildTab(parent) {
	    if (!Modernizr.mq('(min-width: ' + _Utils2.default.em(_conf2.default.mq.md) + 'em)')) {
	        showElement('.tab-quarterly__col', parent, true);
	        desactivateButton(false, parent);
	        var focusedTab = _domUtilities2.default.queryAll(':focus', parent);
	
	        if (!focusedTab.length) {
	            focusedTab = parent.getElementsByClassName('tab-quarterly__button');
	        }
	
	        hideElement('.tab-quarterly__container', parent);
	        if (focusedTab[0].parentNode.children[1]) {
	            focusedTab[0].parentNode.children[1].classList.remove('tab-quarterly__hide');
	        }
	
	        focusedTab[0].classList.add('tab-quarterly__active');
	    } else {
	        desactivateButton(true, parent);
	        showElement('.tab-quarterly__col', parent, true);
	        showElement('.tab-quarterly__container', parent);
	    }
	    defineHeight(parent);
	};
	
	function initTab() {
	    var tabList = _domUtilities2.default.queryAll('.js-tab-quarterly');
	    _domUtilities2.default.onEvent(window, 'optimized-resize', function () {
	        tabList.forEach(function (uniqueTab) {
	            buildTab(uniqueTab);
	        });
	    });
	
	    tabList.forEach(function (uniqueTab) {
	        buildTab(uniqueTab);
	        _domUtilities2.default.queryAll('.tab-quarterly__button', uniqueTab).forEach(function (button) {
	            _domUtilities2.default.onEvents(button, 'touchstart click', function (event) {
	                showElement('.tab-quarterly__col', uniqueTab);
	                event.target.classList.add('tab-quarterly__active');
	                hideElement('.tab-quarterly__container', uniqueTab);
	                event.target.parentNode.children[1].classList.remove('tab-quarterly__hide');
	            });
	        });
	    });
	}
	exports.default = initTab;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = careerFormOption;
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function careerFormOption() {
	    var el = document.querySelector('.js-input-file-tab');
	    if (el != null) {
	        var inputFile = document.querySelector('.js-form-career-input-file').cloneNode(true);
	
	        selectDisplayOtherInput();
	        displayInputFileName(el);
	        addNewInputFile(el, inputFile);
	    }
	};
	
	function selectDisplayOtherInput() {
	    _domUtilities2.default.queryAll('.js-career-form-selectOther').forEach(function (item) {
	        _domUtilities2.default.onEvent(item, 'change', function () {
	            if (item.querySelector('.js-career-form-select').value === 'other') {
	                item.querySelector('.js-career-form-other').classList.remove('form-hidden');
	            } else {
	                item.querySelector('.js-career-form-other').classList.add('form-hidden');
	            }
	        });
	    });
	}
	
	function displayInputFileName(el) {
	    _domUtilities2.default.onEvent(el, 'change', function () {
	        _domUtilities2.default.queryAll('.js-form-input-file', el).forEach(function (item) {
	            var docName = item.querySelector('.js-uploadBtn').value.replace('C:\\fakepath\\', '');
	            item.querySelector('.js-uploadFileName').value = docName;
	        });
	    });
	}
	
	function addNewInputFile(el, inputFile) {
	    _domUtilities2.default.onEvent(el, 'change', function () {
	        if (_domUtilities2.default.queryAll('.js-uploadFileName', el).every(hasAValue)) {
	            var newInput = inputFile.cloneNode(true);
	            el.appendChild(newInput);
	            removeInputFile(newInput);
	        }
	    });
	}
	
	function removeInputFile(item) {
	    _domUtilities2.default.onEvent(item.querySelector('.js-input-file-erase'), 'click', function () {
	        if (item.querySelector('.js-uploadBtn').value.length) {
	            item.parentNode.removeChild(item);
	        }
	    });
	}
	
	function hasAValue(element) {
	    return element.value.length > 0;
	}

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = radioBtnDisplayCommanditeFieldset;
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var displayCommanditeFieldset = function displayCommanditeFieldset() {
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    if (!target) {
	        return;
	    }
	
	    if (target.querySelector('.js-sponsor-form-radioBtn').checked) {
	        target.querySelector('.js-sponsor-form-commandite').classList.remove('form-hidden');
	        target.querySelector('.js-sponsor-form-commandite-error').classList.remove('form-hidden');
	    } else {
	        target.querySelector('.js-sponsor-form-commandite').classList.add('form-hidden');
	        target.querySelector('.js-sponsor-form-commandite-error').classList.add('form-hidden');
	    }
	};
	function radioBtnDisplayCommanditeFieldset() {
	    _domUtilities2.default.queryAll('.js-sponsor-form-radioBtnCommandite').forEach(function (item) {
	        displayCommanditeFieldset(item);
	        _domUtilities2.default.onEvent(item, 'change', function () {
	            displayCommanditeFieldset(item);
	        });
	    });
	}

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = heightBringer;
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * add height 100% from js-start (the inner div) to all the parents div
	 * until js-end (the first child of the div with flex class).
	 *
	 * ^  _ div .jd-end
	 * | |__ .height--full
	 * | |___ .height--full
	 * | |____ .height--full
	 * | |_____ .height--full
	 * | |______ div .js-start .height--full
	 */
	function heightBringer() {
	    _domUtilities2.default.queryAll('.js-end').forEach(function (end) {
	        var start = end.querySelector('.js-start');
	        if (start) {
	            while (start !== end) {
	                start.classList.add('height--full');
	                start = start.parentNode;
	            }
	        }
	    });
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports._getDataFromNode = _getDataFromNode;
	exports.default = cardThumbnail;
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _cardThumbnailTpl = __webpack_require__(28);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get data from card-thumbnail module and return a json
	 *
	 * @export
	 * @param {HTMLElement} element Should be a card-thumbnail module
	 * @returns {Object}
	 */
	function _getDataFromNode(element) {
	    var $image = element.querySelector('[data-card-thumbnail-imghd]');
	    var title = element.querySelector('[data-card-thumbnail-title]').innerHTML;
	    var subtitles = _domUtilities2.default.queryAll('[data-card-thumbnail-subtitle]', element).map(function (subtitleItem) {
	        return {
	            poste: subtitleItem.querySelector('[data-card-thumbnail-poste]').innerHTML,
	            entreprise: subtitleItem.querySelector('[data-card-thumbnail-entreprise]').innerHTML
	        };
	    });
	    var description = element.querySelector('[data-card-thumbnail-desc]').innerHTML;
	    return {
	        image: $image.outerHTML || '',
	        imageHD: $image.getAttribute('data-card-thumbnail-imghd') || '',
	        imageSize: $image.getAttribute('data-card-thumbnail-imgsize') || '',
	        btnlabel: $image.getAttribute('data-card-thumbnail-btnlabel') || '',
	        title: title || '',
	        subtitles: subtitles || '',
	        description: description || ''
	    };
	}
	
	/**
	 * Css class to add on the lightbox container
	 */
	var lightboxContainerCssClasses = ['lightbox--white', 'lightbox--mobilefull'];
	
	/**
	 * Activate a pop-up with more details for card thumbnail
	 *
	 * @export
	 * @param {string} selector
	 * @param {lightbox} lightbox
	 */
	function cardThumbnail() {
	    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var lightbox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    if (!selector || !lightbox) {
	        throw new Error('selector param or lightbox param cannot be null.');
	    }
	
	    _domUtilities2.default.queryAll(selector).forEach(function (elem) {
	        var $button = elem.querySelector('[data-card-thumbnail-btn]');
	        var data = _getDataFromNode(elem);
	
	        _domUtilities2.default.onEvent($button, 'click', function () {
	            lightbox.insertData((0, _cardThumbnailTpl.cardThumbnailTpl)(data));
	            lightbox.open(lightboxContainerCssClasses);
	        });
	    });
	}

/***/ },
/* 28 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * Return a unique string template for all subtitles
	 *
	 * @export
	 * @function
	 * @param {Object[]} subtitles Array of Object subtitle
	 * @param {string} subtitles.poste
	 * @param {string} subtitles.entreprise
	 * @returns {String}
	 */
	var cardThumbnailSubtitlesTpl = exports.cardThumbnailSubtitlesTpl = function cardThumbnailSubtitlesTpl(subtitles) {
	    return subtitles.map(function (objectElem) {
	        var entreprise = '';
	        if (objectElem.entreprise) {
	            entreprise = ', ' + objectElem.entreprise;
	        }
	        return '<p class="h5 card-thumbnail-details__subtitle">' + objectElem.poste + entreprise + '</p>';
	    }).join('');
	};
	
	/**
	 * Return a imageHd download btn if an image HD exist
	 *
	 * @export
	 * @function
	 * @param {String} imageHD
	 * @param {String} btnLabel
	 * @param {String} imageSize
	 */
	var cardThumbnailImageHdTpl = exports.cardThumbnailImageHdTpl = function cardThumbnailImageHdTpl(imageHD, btnLabel, imageSize) {
	    var tpl = '<a class="btn btn--icon card-thumbnail-details__btn" \n                        download target="_blank" href="' + imageHD + '">\n                       <svg class="ico ico--download"><use xlink:href="#download"/></svg>\n                       ' + btnLabel + ' (' + imageSize + ')\n                    </a>';
	    return imageHD !== '' ? tpl : '';
	};
	
	/**
	 * Return a string template of card-thumbnail-details for lightbox
	 *
	 * @export
	 * @function
	 * @param {Object} data Contain all content info
	 * @param {String} data.image Image HTML
	 * @param {String} data.imageHD Image HD url
	 * @param {String} data.imageSize Image size
	 * @param {String} data.btnlabel Download button label
	 * @param {String} data.title Title
	 * @param {Array} data.subtitles subtitle
	 * @param {String} data.description description
	 * @return {String}
	 */
	var cardThumbnailTpl = exports.cardThumbnailTpl = function cardThumbnailTpl(data) {
	    return '<div class="card-thumbnail-details container">\n                <aside class="card-thumbnail-details__picture">\n                    ' + data.image + '\n                    ' + cardThumbnailImageHdTpl(data.imageHD, data.btnlabel, data.imageSize) + '\n                </aside>\n                <article class="content-zone card-thumbnail-details__text">\n                    <h1 class="card-thumbnail-details__title"> ' + data.title + ' </h1>\n                    <div class="card-thumbnail-details__subtitles">\n                    ' + cardThumbnailSubtitlesTpl(data.subtitles) + '\n                    </div>\n                    ' + data.description + '\n                </article>\n            </div>';
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Accordion Initialisation
	 *
	 * @param {String} accordion - Accordion wrapper className
	 * @param {String} accordionTab - Accordion Tab className
	 * @param {String} accordionPanel - Accordion Panel className
	 * @return {Listenner} - Set listenner on accordionTab click action
	 */
	exports.default = function () {
	    var accordion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-accordion';
	    var accordionTab = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '.js-accordion__tab';
	    var accordionPanel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.js-accordion__panel';
	
	
	    if (!accordion) {
	        throw new Error('accordion should not be null.');
	    }
	
	    if (!accordionTab) {
	        throw new Error('accordionTab should not be null.');
	    }
	
	    if (!accordionPanel) {
	        throw new Error('accordionPanel should not be null.');
	    }
	
	    accordion = document.querySelector(accordion);
	
	    var accordionTabs = _domUtilities2.default.queryAll(accordionTab);
	    var accordionPanels = _domUtilities2.default.queryAll(accordionPanel);
	
	    if (!accordion || !accordionTabs || !accordionPanels) {
	        return;
	    }
	
	    accordionTabs.forEach(function (tab) {
	        tab.addEventListener('click', function (event) {
	            event.preventDefault();
	
	            accordionTabs.forEach(function (tab) {
	                return tab.classList.remove('accordion__tab--is-active');
	            });
	            accordionPanels.forEach(function (panel) {
	                panel.classList.remove('accordion__panel--is-active');
	            });
	
	            var targetTab = event.target;
	            var targetPanel = null;
	
	            if (event.target.nodeName !== 'BUTTON') {
	                targetTab = _domUtilities2.default.getClosest(targetTab, 'button');
	                targetPanel = document.querySelector(targetTab.getAttribute('data-id'));
	            } else {
	                targetPanel = document.querySelector(targetTab.getAttribute('data-id'));
	            }
	
	            targetTab.classList.add('accordion__tab--is-active');
	            targetPanel.classList.add('accordion__panel--is-active');
	        });
	    });
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.queryMosaicA = queryMosaicA;
	exports.queryMosaicC = queryMosaicC;
	exports.moveToContainer = moveToContainer;
	
	exports.default = function () {
	    var _this = this;
	
	    _domUtilities2.default.queryAll('.js-mosaic-a').forEach(function (item) {
	        queryMosaicA(item);
	        window.addEventListener('optimized-resize', queryMosaicA.bind(_this, item));
	    });
	
	    _domUtilities2.default.queryAll('.js-mosaic-c').forEach(function (item) {
	        queryMosaicC(item);
	        window.addEventListener('optimized-resize', queryMosaicC.bind(_this, item));
	    });
	};
	
	var _conf = __webpack_require__(1);
	
	var _conf2 = _interopRequireDefault(_conf);
	
	var _Utils = __webpack_require__(10);
	
	var _Utils2 = _interopRequireDefault(_Utils);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * JS DOM move for mosaic A
	 *
	 * @param {HTMLElement} moz Mosaic node
	 */
	function queryMosaicA(moz) {
	    var verticalContainer = moz.querySelector('.js-mosaic__vertical-container');
	    var mainContainer;
	    var verticalTile;
	
	    if (Modernizr.mq('(min-width: ' + _Utils2.default.em(_conf2.default.mq.lg) + 'em)')) {
	        if (!verticalContainer.querySelector('.js-mosaic__vertical-tile')) {
	            mainContainer = moz.querySelector('.mosaic__main-container');
	            verticalTile = mainContainer.querySelector('.js-mosaic__vertical-tile');
	            moveToContainer(verticalTile, verticalContainer);
	        }
	    } else {
	        if (verticalContainer.querySelector('.js-mosaic__vertical-tile')) {
	            mainContainer = moz.querySelector('.mosaic__main-container');
	            verticalTile = verticalContainer.querySelector('.js-mosaic__vertical-tile');
	            moveToContainer(verticalTile, mainContainer);
	        }
	    }
	}
	
	/**
	 * JS DOM move for mosaic C
	 *
	 * @param {HTMLElement} moz Mosaic node
	 */
	function queryMosaicC(moz) {
	    var firstContainer = moz.querySelector('.js-mosaic-c__first-container');
	    var lastContainer = moz.querySelector('.js-mosaic-c__last-container');
	    var movingTile;
	
	    if (Modernizr.mq('(min-width: ' + _Utils2.default.em(_conf2.default.mq.sm) + 'em)')) {
	        if (lastContainer.querySelector('.js-mosaic-c__tile')) {
	            movingTile = lastContainer.querySelector('.js-mosaic-c__tile');
	            moveToContainer(movingTile, firstContainer);
	        }
	    } else {
	        if (!lastContainer.querySelector('.js-mosaic-c__tile')) {
	            movingTile = firstContainer.querySelector('.js-mosaic-c__tile');
	            moveToContainer(movingTile, lastContainer);
	        }
	    }
	}
	
	/**
	 * Move node
	 *
	 * @param {HTMLElement} el Node to move
	 * @param {HTMLElement} destContainer Parent node container
	 */
	function moveToContainer(el, destContainer) {
	    var duplicateNode = el.cloneNode(true);
	    el.parentNode.removeChild(el);
	    destContainer.appendChild(duplicateNode);
	}
	
	/**
	 * Active responsive moving node for mosaic type A and C
	 */

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.DropdownMenu = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = displayDropdownMenu;
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * DropdownMenu Class
	 *
	 * @export
	 * @class DropdownMenu
	 */
	var DropdownMenu = exports.DropdownMenu = function () {
	
	    /**
	     * Create Menu dropdown instance
	     * @param {HTMLElement} $dropdownNode
	     * @param {Object} customOptions - {Optional} options custom
	     * @param {String} customOptions.actionSelector
	     * @param {String} customOptions.classNameOpenState
	     */
	    function DropdownMenu($dropdownNode) {
	        var customOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        _classCallCheck(this, DropdownMenu);
	
	        if (!$dropdownNode) {
	            throw new Error('dropdownNode param should be defined and an HTMLElement object');
	        }
	        this.options = {
	            actionSelector: '.js-dropdownMenu-action',
	            classNameOpenState: 'dropdownMenu--open'
	        };
	        if (customOptions !== null) {
	            this.options = _domUtilities2.default.extend(this.options, customOptions);
	        }
	        this.$dropDown = $dropdownNode;
	        this.$actionNode = this.$dropDown.querySelector(this.options.actionSelector);
	        this.isOpen = _domUtilities2.default.parseBoolean(this.$actionNode.getAttribute('aria-expanded'));
	    }
	
	    /**
	     * Open the dropDown menu. Set an event listner on document to close it
	     */
	
	
	    _createClass(DropdownMenu, [{
	        key: 'open',
	        value: function open() {
	            this.isOpen = true;
	            this.$dropDown.classList.add(this.options.classNameOpenState);
	            this.$actionNode.setAttribute('aria-expanded', 'true');
	
	            this._bindedCloseOnOuterClick = this._closeOnOuterClick.bind(this);
	            document.addEventListener('click', this._bindedCloseOnOuterClick);
	        }
	
	        /**
	         * Close the dropDown menu. Remove the event listener on document
	         */
	
	    }, {
	        key: 'close',
	        value: function close() {
	            this.isOpen = false;
	            this.$dropDown.classList.remove(this.options.classNameOpenState);
	            this.$actionNode.setAttribute('aria-expanded', 'false');
	
	            document.removeEventListener('click', this._bindedCloseOnOuterClick);
	        }
	
	        /**
	         * Toggle state of the dropDown menu.
	         */
	
	    }, {
	        key: 'toggleState',
	        value: function toggleState() {
	            this.isOpen ? this.close() : this.open();
	        }
	
	        /**
	         * Function to close drop down if user click outside the dropDown
	         * @param {Event} event
	         */
	
	    }, {
	        key: '_closeOnOuterClick',
	        value: function _closeOnOuterClick(event) {
	            if (event.target !== this.$actionNode) {
	                this.close();
	            }
	        }
	
	        /**
	         * Initialize the the dropdown
	         */
	
	    }, {
	        key: 'initActionListener',
	        value: function initActionListener() {
	            this.$dropDown.addEventListener('click', this.toggleState.bind(this));
	        }
	    }]);
	
	    return DropdownMenu;
	}();
	
	/**
	 * Active the dropDown menu
	 * @param {String} dropDownSelector the selector of dropDown
	 * @return {DropdownMenu[]} Array of DropdownMenu instances
	 */
	
	
	function displayDropdownMenu() {
	    var dropDownSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-dropdownMenu';
	
	    return _domUtilities2.default.queryAll(dropDownSelector).forEach(function ($item) {
	        var dropDown = new DropdownMenu($item);
	        dropDown.initActionListener();
	        return dropDown;
	    });
	}

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var InitBurger = function () {
	    function InitBurger() {
	        _classCallCheck(this, InitBurger);
	
	        this.burger = '[data-burger="true"]';
	        this.burgerNode = null;
	        this.burgerNavigation = '[data-burger-navigation]';
	        this.actionNodesSelector = '[data-burger-action], a';
	        this.openHandler = '[data-burger-action="open"]';
	        this.openChildHandler = '[data-burger-action="openChild"]';
	        this.closeHandler = '[data-burger-action="close"]';
	        this.closeChildHandler = '[data-burger-action="closeChild"]';
	        this.activeClass = 'burger--is-active';
	        this.overlayClass = 'burger-overlay';
	        this.burgerNavigationActiveClass = 'burger__navigation--has-children-open';
	    }
	
	    _createClass(InitBurger, [{
	        key: '_openBurger',
	        value: function _openBurger() {
	            document.querySelector('html').classList.toggle(this.activeClass);
	            this.a11y('open');
	            this.burgerNode.querySelector(this.closeHandler).focus();
	        }
	    }, {
	        key: '_closeBurger',
	        value: function _closeBurger() {
	            document.querySelector('html').classList.remove(this.activeClass);
	            this.a11y('close');
	        }
	    }, {
	        key: '_clickOutter',
	        value: function _clickOutter() {
	
	            if (!document.querySelector('html').classList.contains(this.activeClass)) {
	                return;
	            }
	
	            this._closeBurger();
	        }
	    }, {
	        key: '_openChildren',
	        value: function _openChildren(event) {
	            var targetParent = event.target.parentNode;
	            var targetChild = targetParent.querySelector('[data-burger-state]');
	
	            if (!targetChild) {
	                return;
	            }
	
	            document.querySelector(this.burgerNavigation).classList.add(this.burgerNavigationActiveClass);
	
	            targetChild.setAttribute('data-burger-state', 'open');
	        }
	    }, {
	        key: '_closeChildren',
	        value: function _closeChildren(event) {
	            var targetParent = _domUtilities2.default.getClosest(event.target, '[data-burger-state]');
	
	            if (!targetParent) {
	                return;
	            }
	
	            document.querySelector(this.burgerNavigation).classList.remove(this.burgerNavigationActiveClass);
	
	            targetParent.setAttribute('data-burger-state', 'close');
	        }
	    }, {
	        key: 'a11y',
	        value: function a11y(state) {
	            _domUtilities2.default.queryAll(this.actionNodesSelector, this.burgerNode).forEach(function (item) {
	                if (state === 'close') {
	                    item.setAttribute('tabindex', '-1');
	                } else if (state === 'open') {
	                    item.setAttribute('tabindex', '0');
	                }
	            });
	        }
	    }, {
	        key: 'init',
	        value: function init(burgerNode) {
	            var _this = this;
	
	            this.burgerNode = burgerNode;
	            this.a11y('close');
	
	            document.querySelector(this.openHandler).addEventListener('click', this._openBurger.bind(this));
	
	            document.querySelector(this.closeHandler).addEventListener('click', this._closeBurger.bind(this));
	
	            document.querySelector('.' + this.overlayClass).addEventListener('click', this._closeBurger.bind(this));
	
	            _domUtilities2.default.queryAll(this.openChildHandler).forEach(function (node) {
	                node.addEventListener('click', function (event) {
	                    _this._openChildren(event);
	                });
	            });
	
	            _domUtilities2.default.queryAll(this.closeChildHandler).forEach(function (node) {
	                node.addEventListener('click', function (event) {
	                    _this._closeChildren(event);
	                });
	            });
	        }
	    }]);
	
	    return InitBurger;
	}();
	
	;
	
	exports.default = InitBurger;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var groupSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-tabgroup]';
	    var filterSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '[data-tabfilter]';
	    var panelSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '[data-tabpanel]';
	
	
	    return _domUtilities2.default.queryAll(groupSelector).map(function (group) {
	        var panels = _domUtilities2.default.queryAll(panelSelector, group);
	        var filters = _domUtilities2.default.queryAll(filterSelector, group);
	        filters.forEach(function (itemFilter) {
	            itemFilter.addEventListener('click', function (event) {
	                event.preventDefault();
	                switchTab(event.target, filters, panels);
	            });
	        });
	
	        return {
	            panels: panels,
	            filters: filters
	        };
	    });
	};
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	
	/**
	 * Switch state class
	 * @param {HTMLElement} filterActionNode
	 * @param {HTMLElement[]} filters node array
	 * @param {HTMLElement[]} panels node array
	 */
	
	
	/**
	 * TabPanel init
	 *
	 * @param {String} groupSelector - Css Selector
	 * @param {String} tabSelector - Css Selector
	 * @param {String} panelSelector - Css Selector
	 * @return {Object[]} Array of groups contains panels and filters array
	 */
	function switchTab(filterActionNode, filters, panels) {
	    panels.forEach(function (item) {
	        _domUtilities2.default.unsetClass(item, 'state--active');
	    });
	
	    filters.forEach(function (item) {
	        _domUtilities2.default.unsetClass(item, 'state--active');
	    });
	
	    _domUtilities2.default.setClass(filterActionNode, 'state--active');
	    _domUtilities2.default.setClass(document.querySelector(filterActionNode.getAttribute('href')), 'state--active');
	}

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports._syncInput = _syncInput;
	exports._setVisibleSearch = _setVisibleSearch;
	exports.default = syncSearchPage;
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sync value from header input search to the hidden input on form
	 *
	 * @function
	 * @param {HTMLElement} $visible
	 * @param {HTMLElement} $hidden
	 */
	function _syncInput($visible, $hidden) {
	    if (!$visible || !$hidden) {
	        throw new Error('Missing $visible and/or $hidden node');
	    }
	    $visible.value = $hidden.value;
	
	    $visible.addEventListener('keydown', function (event) {
	        $hidden.value = event.target.value;
	        var keyCode = event.which || event.keyCode;
	        if (keyCode === 13) {
	            _domUtilities2.default.getClosest($hidden, 'form').submit();
	        }
	    });
	};
	
	/**
	 * Set search input on the header
	 *
	 * @function
	 * @param {Object} options - options
	 * @param {string} options.dropAreaSelector - options
	 * @param {string} options.headerSelector - options
	 * @param {string} options.headerModifier - options
	 * @param {string} html - Html to insert in place of the hero title
	 */
	function _setVisibleSearch(options, html) {
	    var dropItem = document.querySelector(options.dropAreaSelector);
	    dropItem.insertAdjacentHTML('afterend', html);
	    dropItem.parentNode.removeChild(dropItem);
	    document.querySelector(options.headerSelector).classList.add(options.headerModifier);
	}
	
	/**
	 * Set a search input on the header and keep it sync with the original form
	 *
	 * @function
	 * @param {Object} customOptions - To overwide options
	 */
	function syncSearchPage() {
	    var customOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var options = {
	        inputSourceId: 'search-portlet-input',
	        inputVisibleId: 'search-portlet-input-visible',
	        dropAreaSelector: '[data-hero-page-title]',
	        headerSelector: '.header',
	        headerModifier: 'header--search'
	    };
	    options = _domUtilities2.default.extend(options, customOptions);
	    var heroForm = '<div class="form hero__form">\n                        <input title="' + QUEBECOR_TRANSLATE.search + '" type="text"\n                            class="form__item form__item--search" id="' + options.inputVisibleId + '"/>\n                    </div>';
	    var inputSource = document.getElementById(options.inputSourceId);
	
	    if (inputSource) {
	        _setVisibleSearch(options, heroForm);
	        _syncInput(document.getElementById(options.inputVisibleId), inputSource);
	    }
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise, fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Quote = function () {
	    function Quote() {
	        _classCallCheck(this, Quote);
	
	        this.url = '/o/rest/quotes/';
	        this.currency = '$';
	        this.render = document.querySelector('.header-handler__box-rates');
	    }
	
	    _createClass(Quote, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	            if (!this.render) {
	                return;
	            }
	
	            if (refresh) {
	                var node = document.querySelector('[quote-box]');
	                node.classList.add('header-handler__box--is-loading');
	            }
	
	            this.get().then(function (data) {
	                if (data.length === 0) {
	                    Promise.reject('Data quote response is empty');
	                }
	
	                return _this.createBoxeRate(data);
	            }).then(function (boxesTemplate) {
	                if (boxesTemplate.length > 0 && _this.render) {
	                    (function () {
	                        var node = _this.render;
	                        node.innerHTML = '';
	                        boxesTemplate.forEach(function (box) {
	                            return node.innerHTML += box;
	                        });
	                    })();
	                }
	            }).then(function () {
	                var node = document.querySelector('[quote-box]');
	                if (!node) {
	                    Promise.reject();
	                }
	
	                setTimeout(function () {
	                    node.classList.remove('header-handler__box--is-loading');
	                }, 1000);
	
	                setTimeout(function () {
	                    _this.init(true);
	                }, 30000);
	
	                Promise.resolve();
	            }).catch(function (error) {
	                console.error('Something went wrong with this request', error);
	
	                setTimeout(function () {
	                    _this.init(true);
	                }, 30000);
	            });
	        }
	    }, {
	        key: 'refresh',
	        value: function refresh() {
	            this.init(true);
	        }
	    }, {
	        key: 'get',
	        value: function get() {
	            return fetch(this.url, { credentials: 'include' }).then(function (response) {
	                return response.json();
	            }).then(function (data) {
	                var quotes = data.Quotes;
	
	                if (quotes && quotes.length > 0) {
	                    return quotes;
	                }
	            }).catch(function (error) {
	                console.error('Something went wrong with request', error);
	            });
	        }
	
	        /**
	         * createBoxeRate - return an array of stringify template
	         *
	         * @param {Array[{Object}]} [data=null]
	         * @returns {Array[{Object}]} return an array of stringify template
	         * @memberof Quote
	         */
	
	    }, {
	        key: 'createBoxeRate',
	        value: function createBoxeRate() {
	            var _this2 = this;
	
	            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!data) {
	                return;
	            }
	            /*eslint-disable */
	            return data.map(function (item) {
	                var variationClassName = _this2.getVariationClassName(item.Trend);
	                var label = _this2.render.getAttribute('quote-i18n-label');
	
	                return '\n                <div class="header-handler__box-rate">\n                    <div class="header-handler__box-label">\n                        <span quote-rate-ExchangeName>' + item.ExchangeName + '</span> : <span quote-rate-QuoteName>' + item.QuoteName + '</span>\n                    </div>\n                    <div class="header-handler__box-value">\n                        <span class="header-handler__box-value-last" quote-rate-Last>\n                            ' + parseFloat(item.Last).toFixed(2) + ' ' + _this2.currency + '\n                        </span>\n                        <span class="header-handler__box-value-variation ' + variationClassName + '" quote-rate-PercentChange>\n                        ' + (item.PercentChange > 0 ? '+' + parseFloat(item.PercentChange).toFixed(2) : parseFloat(item.PercentChange).toFixed(2)) + '\n                        </span>\n                    </div>\n                    <p class="header-handler__box-last-update">\n                        ' + _this2.formatDate(item.LastTradeTime) + '\n                    </p>\n                </div>\n            ';
	            });
	            /*eslint-enable */
	        }
	
	        /**
	         * formatDate - Transform iso date to dd/mm/yyyy
	         *
	         *
	         * @param {String} [date=null]
	         * @returns {String} String date formated as follow dd/mm/yyyy
	         * @memberof Quote
	         */
	
	    }, {
	        key: 'formatDate',
	        value: function formatDate() {
	            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!date) {
	                return;
	            }
	
	            var desiredDate = new Date(date);
	            // Add 1 because month start at 0
	            var month = String(('0' + (desiredDate.getMonth() + 1)).slice(-2));
	            var day = String(('0' + desiredDate.getDate()).slice(-2));
	            var year = String(desiredDate.getFullYear());
	            var hours = String(('0' + desiredDate.getHours()).slice(-2));
	            var minutes = String(('0' + desiredDate.getMinutes()).slice(-2));
	
	            return day + '/' + month + '/' + year + ' ' + hours + ':' + minutes;
	        }
	
	        /**
	         * getVariationClassName - Return a bemify className
	         *
	         * @param {String} [trend=null]
	         * @returns
	         * @memberof Quote
	         */
	
	    }, {
	        key: 'getVariationClassName',
	        value: function getVariationClassName() {
	            var trend = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            var baseClassName = 'header-handler__box-value-variation';
	
	            switch (trend) {
	                case 'DECREASE':
	                    return baseClassName + '--decrease';
	                case 'INCREASE':
	                    return baseClassName + '--increase';
	                default:
	                    return '';
	            }
	        }
	    }]);
	
	    return Quote;
	}();
	
	exports.default = Quote;
	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(39)))

/***/ },
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = self.fetch;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36)))

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise, fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _timeago = __webpack_require__(41);
	
	var _timeago2 = _interopRequireDefault(_timeago);
	
	var _responsiveSwipeItem = __webpack_require__(21);
	
	var _responsiveSwipeItem2 = _interopRequireDefault(_responsiveSwipeItem);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * return the current language
	 */
	var getDocumentLang = function getDocumentLang() {
	    var html = document.querySelector('html');
	
	    if (!html) {
	        return;
	    }
	
	    var lang = html.getAttribute('lang');
	
	    if (!lang) {
	        return 'en';
	    }
	    return lang.substring(0, 2);
	};
	
	/**
	 * Load the selected language for timeago plugin.
	 * @param {*} number
	 * @param {*} index
	 */
	var localeFR = function localeFR(number, index) {
	    return [['à l\'instant', 'dans un instant'], ['il y a %s secondes', 'dans %s secondes'], ['il y a 1 minute', 'dans 1 minute'], ['il y a %s minutes', 'dans %s minutes'], ['il y a 1 heure', 'dans 1 heure'], ['il y a %s heures', 'dans %s heures'], ['il y a 1 jour', 'dans 1 jour'], ['il y a %s jours', 'dans %s jours'], ['il y a 1 semaine', 'dans 1 semaine'], ['il y a %s semaines', 'dans %s semaines'], ['il y a 1 mois', 'dans 1 mois'], ['il y a %s mois', 'dans %s mois'], ['il y a 1 an', 'dans 1 an'], ['il y a %s ans', 'dans %s ans']][index];
	};
	
	/**
	 * Remove focus on elements when page is not in foreground
	 * @param {*} el Required. Element affected by focus out if page is in background
	 */
	function removeFocusWhenTabOpened(el) {
	    var visibilityChange = void 0;
	
	    if (typeof document.hidden !== 'undefined') {
	        visibilityChange = 'visibilitychange';
	    } else if (typeof document.msHidden !== 'undefined') {
	        visibilityChange = 'msvisibilitychange';
	    } else if (typeof document.webkitHidden !== 'undefined') {
	        visibilityChange = 'webkitvisibilitychange';
	    }
	
	    _domUtilities2.default.onEvent(document, visibilityChange, function () {
	        if (document.hidden && el.contains(document.activeElement)) {
	            document.activeElement.blur();
	        }
	    });
	}
	
	var LastTweet = function () {
	    function LastTweet() {
	        _classCallCheck(this, LastTweet);
	
	        this.url = '/o/rest/twitter/latest/';
	        this.render = document.querySelector('.last-tweet-list__items');
	    }
	
	    _createClass(LastTweet, [{
	        key: 'init',
	        value: function init() {
	            var _this = this;
	
	            if (!this.render) {
	                return;
	            }
	            this.get().then(function (data) {
	                if (data.length === 0) {
	                    Promise.reject('Last tweet response is empty');
	                }
	                var tweet;
	                var tweetCard;
	
	                _timeago2.default.register('fr', localeFR);
	                var timeagoInstance = (0, _timeago2.default)();
	
	                for (tweet in data) {
	                    if (data[tweet].extendedMediaEntities[0] && data[tweet].extendedMediaEntities[0].mediaURLHttps) {
	                        tweetCard = _this.createMediaTweet(data[tweet], tweet, timeagoInstance);
	                    } else {
	                        tweetCard = _this.createTweet(data[tweet], tweet, timeagoInstance);
	                    }
	                    _this.render.innerHTML += tweetCard;
	                }
	            }).then(function () {
	                var tweets = _domUtilities2.default.queryAll('.last-tweet', _this.render);
	                (0, _responsiveSwipeItem2.default)('data-responsive-swipe-tweet');
	                _domUtilities2.default.hoverOnScrollForMobile(tweets, 'last-tweet--hover');
	                removeFocusWhenTabOpened(_this.render);
	            }).catch(function (error) {
	                console.error('Something went wrong with this request', error);
	            });
	        }
	    }, {
	        key: 'get',
	        value: function get() {
	            return fetch(this.url, { credentials: 'include' }).then(function (response) {
	                return response.json();
	            }).then(function (data) {
	                var lastTweet = data;
	
	                if (lastTweet && lastTweet.length > 0) {
	                    return lastTweet;
	                }
	            }).catch(function (error) {
	                console.error('[GET] Something went wrong with request', error);
	            });
	        }
	
	        /**
	         * Take a stringified json and return a last-tweet video or image html element
	         * @param {String} tweet - The raw response of api
	         * @param {String} index - Index of the current tweet
	         * @param {String} timeagoInstance - an instance of timeago with the correct language loaded
	         */
	
	    }, {
	        key: 'createMediaTweet',
	        value: function createMediaTweet() {
	            var tweet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var index = arguments[1];
	            var timeagoInstance = arguments[2];
	
	            if (!tweet) {
	                return;
	            }
	            tweet.text = this.ellipsisText(tweet.text);
	            tweet.text = this.getMentions(tweet.text, tweet.userMentionEntities);
	            tweet.text = this.getHashtags(tweet.text);
	            tweet.text = this.getUrls(tweet.text);
	
	            var tweetType = null;
	            if (tweet.extendedMediaEntities[0].type === 'photo') {
	                tweetType = 'last-tweet--with-image';
	            } else {
	                tweetType = 'last-tweet--with-video';
	            }
	            var tweetThumb;
	            if (tweet.extendedMediaEntities[0].sizes) {
	                tweetThumb = tweet.extendedMediaEntities[0].mediaURLHttps + ':medium';
	            }
	            return '\n            <a href="' + tweet.tweetURL + '" target="_blank" class="last-tweet last-tweet__item ' + tweetType + '">\n                <div class="last-tweet__image" style="background-image: url(' + tweetThumb + ');\n                background-size: cover; background-position: center center;">\n                    <div class="last-tweet__overlay">\n                        <svg class="ico ico--round-play">\n                            <use xlink:href="#round-play"/>\n                        </svg>\n                    </div>\n                </div>\n                <span class="last-tweet__card"></span>\n                <div class="last-tweet__mask">\n                    <div class="last-tweet__info">\n                        <div class="last-tweet-header">\n                            <svg class="ico ico--time"><use xlink:href="#time"/></svg>\n                            <span>' + timeagoInstance.format(tweet.createdAt, getDocumentLang()) + '</span>\n                        </div>\n                        <p class="last-tweet-content">' + tweet.text + '</p>\n                        <svg class="ico ico--round-go last-tweet__icon last-tweet-footer">\n                            <use xlink:href="#round-go"/>\n                        </svg>\n                    </div>\n                </div>\n            </a>\n        ';
	        }
	
	        /**
	         * Take a stringified json and return a last-tweet html element
	         * @param {String} tweet - The raw response of api
	         * @param {String} index - Index of the current tweet
	         * @param {String} timeagoInstance - an instance of timeago with the correct language loaded
	         */
	
	    }, {
	        key: 'createTweet',
	        value: function createTweet() {
	            var tweet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var index = arguments[1];
	            var timeagoInstance = arguments[2];
	
	            if (!tweet) {
	                return;
	            }
	            tweet.text = this.ellipsisText(tweet.text);
	            tweet.text = this.getMentions(tweet.text, tweet.userMentionEntities);
	            tweet.text = this.getHashtags(tweet.text);
	            tweet.text = this.getUrls(tweet.text);
	
	            var tweetStyle;
	            if (index === '0' || index === '4') {
	                tweetStyle = 'last-tweet-delta';
	            } else if (index === '2' || index === '5') {
	                tweetStyle = 'last-tweet-gamma';
	            }
	
	            var tweetLabel = 'See it on our Twitter account';
	            if (document.querySelector('.js-last-tweet-label') && document.querySelector('.js-last-tweet-label').innerText) {
	                tweetLabel = document.querySelector('.js-last-tweet-label').innerText;
	            }
	
	            return '\n            <a href="' + tweet.tweetURL + '" target="_blank" class="last-tweet last-tweet__item ' + tweetStyle + '">\n                <span class="last-tweet__card"></span>\n                    <div class="last-tweet__container">\n                        <div class="last-tweet-header">\n                            <svg class="ico ico--time"><use xlink:href="#time"/></svg>\n                            <span>' + timeagoInstance.format(tweet.createdAt, getDocumentLang()) + '</span>\n                        </div>\n                        <p class="last-tweet-content">' + tweet.text + '</p>\n                    </div>\n                <div class="last-tweet__mask">\n                    <div class="last-tweet__info last-tweet-footer">\n                        <span class="last-tweet__label">' + tweetLabel + '</span>\n                        <svg class="ico ico--round-go last-tweet__icon">\n                            <use xlink:href="#round-go"/>\n                        </svg>\n                    </div>\n                </div>\n            </a>\n        ';
	        }
	
	        /**
	         * Parse a string and reduce text size
	         * @param {String} msg - a tweet
	         * @param {Number} max - max number of char
	         */
	
	    }, {
	        key: 'ellipsisText',
	        value: function ellipsisText() {
	            var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 163;
	            // 160 + 3 for the ellipsis
	            if (!msg) {
	                return;
	            }
	
	            if (msg.length > max) {
	                return msg.substring(0, max - 3) + '...';
	            } else {
	                return msg;
	            }
	        }
	
	        /**
	         * Parse a string and return it with mentions enclosed by <span></span>
	         * @param {String} msg - a tweet
	         * @param {String} mentions - a list of mentions
	         */
	
	    }, {
	        key: 'getMentions',
	        value: function getMentions() {
	            var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	            var mentions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (!msg) {
	                return;
	            }
	
	            if (mentions) {
	                var mentionsList = mentions.map(function (mention) {
	                    return mention.screen_name;
	                }).join('|');
	                var pattern = '\@(' + mentionsList + ')\\b';
	                var final = msg.replace(new RegExp(pattern, 'gi'), '<span class="last-tweet__hashtag">@$1</span>');
	
	                return final;
	            }
	        }
	
	        /**
	         * Parse a string and return it with hashtags enclosed by <span></span>
	         * @param {String} msg - a tweet
	         */
	
	    }, {
	        key: 'getHashtags',
	        value: function getHashtags() {
	            var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!msg) {
	                return;
	            }
	
	            var hashWithHtml = msg.replace(/(^|\W)(#[a-z\d][\wœáéíóäëiöúàèììù-]*)/ig, " <span class='last-tweet__hashtag'>$2</span>");
	            return hashWithHtml;
	        }
	
	        /**
	         * Parse a string and return it with url enclosed by <span></span>
	         * @param {String} msg - a tweet
	         */
	
	    }, {
	        key: 'getUrls',
	        value: function getUrls() {
	            var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	            if (!msg) {
	                return;
	            }
	
	            var msgWithUrls = msg.replace(/((http|https|www)\b:\/\/(\w[.,\/]?)+)/ig, " <span class='last-tweet__hashtag'>$1</span>");
	
	            return msgWithUrls;
	        }
	    }]);
	
	    return LastTweet;
	}();
	
	exports.default = LastTweet;
	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(36), __webpack_require__(39)))

/***/ },
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _anchor = __webpack_require__(18);
	
	function scrollToBottom() {
	
	    if (document.querySelector('.js-job-offer-btn')) {
	        document.querySelector('.js-job-offer-btn').addEventListener('click', function (event) {
	            event.preventDefault();
	            (0, _anchor.setScrollTo)(document.querySelector('.js-job-offer-dest'));
	        });
	    }
	}
	
	exports.default = scrollToBottom;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    addClassToPageLayout();
	
	    if (window.innerWidth > _conf2.default.mq['md']) {
	        squareListAlign();
	    }
	
	    _domUtilities2.default.onEvent(window, 'optimized-resize', function () {
	        if (window.innerWidth > _conf2.default.mq['md']) {
	            squareListAlign();
	        }
	    });
	};
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _conf = __webpack_require__(1);
	
	var _conf2 = _interopRequireDefault(_conf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adjust padding-top of square-list without title
	 */
	var squareListAlign = function squareListAlign() {
	    var nodes = _domUtilities2.default.queryAll('[class*="page__layout--2"] .square-list');
	
	    if (nodes.length === 0) {
	        return;
	    }
	
	    var titles = nodes.map(function (node) {
	        var title = node.querySelector('.square-list__title');
	
	        if (!title) {
	            return 0;
	        }
	
	        var marginBottom = parseInt(window.getComputedStyle(title).getPropertyValue('margin-bottom'));
	
	        return title.offsetHeight + marginBottom;
	    });
	
	    if (titles.length === 0) {
	        return;
	    }
	
	    var offsetHeight = Math.max.apply(Math, titles);
	
	    var squareToAlign = _domUtilities2.default.queryAll('[class*="page__layout--2"] .square-list--no-title');
	
	    nodes.map(function (square) {
	        var title = square.querySelector('.square-list__title');
	
	        if (!title) {
	            return;
	        }
	
	        var marginBottom = parseInt(window.getComputedStyle(title).getPropertyValue('margin-bottom'));
	        var offsetWithoutMargin = offsetHeight - marginBottom;
	
	        return title.setAttribute('style', 'height: ' + offsetWithoutMargin + 'px');
	    });
	
	    if (squareToAlign.length === 0) {
	        return;
	    }
	
	    squareToAlign.map(function (square) {
	        return square.setAttribute('style', 'padding-top: ' + offsetHeight + 'px');
	    });
	};
	
	var addClassToPageLayout = function addClassToPageLayout() {
	    var pageLayouts = _domUtilities2.default.queryAll('.page__layout .page__layout');
	
	    if (pageLayouts.length > 0) {
	        pageLayouts.forEach(function (pageLayout) {
	            var squareList = pageLayout.querySelector('.square-list');
	
	            if (squareList) {
	                pageLayout.classList.add('has-square');
	            }
	        });
	    }
	};
	
	;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function () {
	    var boxes = _domUtilities2.default.queryAll('.card-flex');
	
	    if (!boxes || boxes.length === 0) {
	        return;
	    }
	
	    boxes.forEach(function (box) {
	        var boxContent = box.querySelector('.card-flex__description');
	        var boxTitle = box.querySelector('.card-flex__title');
	
	        if (!boxContent || !boxTitle) {
	            return;
	        }
	
	        var boxContentText = boxContent.textContent;
	        var boxTitleContentText = boxTitle ? boxTitle.textContent : null;
	
	        // Add 5px to conf.mq.sm in order to prevent bug on firefox
	        if (window.innerWidth > _conf2.default.mq.sm - 5) {
	            // Fix a bug with safari and mosaic DOM manipulation
	            // When page load, truncated function finished before mosaic paint is fully accomplished
	            setTimeout(function () {
	                boxTruncate(boxContent, boxTitle, box.offsetHeight, boxContentText, boxTitleContentText);
	            }, 500);
	        }
	
	        _domUtilities2.default.onEvent(window, 'optimized-resize', _domUtilities2.default.setThrottle(function () {
	            // Add 5px to conf.mq.sm in order to prevent bug on firefox
	            if (window.innerWidth > _conf2.default.mq.sm - 5) {
	                boxTruncate(boxContent, boxTitle, box.offsetHeight, boxContentText, boxTitleContentText, true);
	            } else {
	                var isShaveBoxContent = boxContent.querySelector('.js-shave') ? true : false;
	                var isShaveBoxTitle = boxTitle.querySelector('.js-shave') ? true : false;
	
	                if (isShaveBoxContent) {
	                    boxContent.textContent = boxContentText;
	                }
	
	                if (isShaveBoxTitle) {
	                    boxTitle.textContent = boxTitleContentText;
	                }
	            }
	        }, 200));
	    });
	};
	
	var _shave = __webpack_require__(45);
	
	var _shave2 = _interopRequireDefault(_shave);
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _conf = __webpack_require__(1);
	
	var _conf2 = _interopRequireDefault(_conf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable max-statements */
	/**
	 * boxTruncate - Truncate box content based on content height ratio
	 * e.g: if my content represent more than 50% of the ratio i want to truncate it
	 *
	 * @param {DOMElement} boxContent
	 * @param {DOMElement} boxTitle
	 * @param {Number} boxHeight
	 * @param {String} boxContentText
	 * @param {String} boxTitleContentText
	 * @param {Boolean} isScroll
	 */
	var boxTruncate = function boxTruncate() {
	    var boxContent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	    var boxTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	    var boxHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var boxContentText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	    var boxTitleContentText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	    var isScroll = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
	
	    if (!boxContent || !boxTitle || !boxHeight || !boxContentText || !boxTitleContentText) {
	        return;
	    }
	
	    var isShaveBoxContent = boxContent.querySelector('.js-shave') ? true : false;
	    var isShaveBoxTitle = boxTitle.querySelector('.js-shave') ? true : false;
	
	    if (isShaveBoxContent) {
	        boxContent.textContent = boxContentText;
	    }
	
	    if (isShaveBoxTitle) {
	        boxTitle.textContent = boxTitleContentText;
	    }
	
	    var boxTitleHeight = boxTitle.offsetHeight;
	    var contentHeightRatio = (boxContent.offsetHeight + boxTitleHeight) / boxHeight;
	
	    if (contentHeightRatio >= 0.50) {
	        isScroll ? (0, _shave2.default)(boxContent, 120) : (0, _shave2.default)(boxContent, 100);
	
	        if (boxTitleHeight > 70) {
	            (0, _shave2.default)(boxTitle, 90);
	        }
	    }
	};
	
	;
	/* eslint-enable max-statements */

/***/ },
/* 45 */,
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = scrollToFormError;
	
	var _domUtilities = __webpack_require__(4);
	
	var _domUtilities2 = _interopRequireDefault(_domUtilities);
	
	var _ScrollTo = __webpack_require__(7);
	
	var _ScrollTo2 = _interopRequireDefault(_ScrollTo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollToFormError() {
	    _domUtilities2.default.queryAll('.js-form').forEach(function (form) {
	        var nodesError = _domUtilities2.default.queryAll('.error', form);
	
	        if (nodesError.length) {
	            var offset = 0;
	            if (document.body.querySelector('.navbar')) {
	                offset += document.body.querySelector('.navbar').getBoundingClientRect().height;
	            }
	            if (document.body.querySelector('.anchors')) {
	                offset += document.body.querySelector('.anchors').getBoundingClientRect().height;
	            }
	
	            var positionToGo = nodesError.map(function (item) {
	                return item.getBoundingClientRect().top;
	            }).reduce(function (acc, current) {
	                return !acc || acc > current ? current : acc;
	            }, null);
	
	            var offsetScroll = positionToGo - (offset + (document.body.getBoundingClientRect().top - 10));
	
	            (0, _ScrollTo2.default)(document.scrollingElement || document.documentElement, offsetScroll, 400);
	        }
	    });
	}

/***/ }
]);


// WEBPACK FOOTER //
// app.js